export default  {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "Escrime XXI N⁰. 120",
    "shortTitle": "",
    "description": "",
    "width": 1173,
    "height": 880,
    "currentLanguage": "FR",
    "languages": [{
      code: "EN",
      text: "English",
      href: "https://escrime-xxi.fie.org/120/en/"
    },
    {
      code: "FR",
      text: "French",
      href: "https://escrime-xxi.fie.org/120/fr/"
    },
    {
      code: "ES",
      text: "Spanish",
      href: "https://escrime-xxi.fie.org/120/es/"
    }],
    "basePath": "/120/fr",
    // "basePath": "",
    "companyLogo": "logo.png",
    "publishURL": "https://escrime-xxi.fie.org/120/fr/static/_thumbs/",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
      "doublePage": false,
      "rightToLeft": false,
      "searchEnabled": true,
      "downloadEnabled": false,
      "downloadPath": '/120/fr/static/_content/escrime-120-fr.pdf',
      "printEnabled": false,
      "zoomEnabled": true,
      "contentsEnabled": true,
      "languagesEnabled": true,
      "editionsEnabled": false,
      "mobileSwitch": true,
      "guideEnabled": false,
    },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 1-title" style="top:84px;left:52px;" src="/120/fr/static/_content/1-title-1.png">
        <img class="abs halfScale 1-title" style="top:210px;left:52px;" src="/120/fr/static/_content/1-title-2.png">
        <img class="abs halfScale 1-title" style="top:1px;left:290px;" src="/120/fr/static/_content/1-numerals-1.png">
        <img class="abs halfScale 1-title" style="top:84px;left:824px;" src="/120/fr/static/_content/1-ed-1.png">
        <!-- <img class="abs halfScale 1-title" style="top:84px;left:957px;" src="/120/fr/static/_content/logo.png"> -->
        <img class="abs halfScale 1-title" style="top:329px;left:52px;" src="/120/fr/static/_content/1-sub-1.png">
        <img class="abs halfScale 1-title" style="top:433px;left:53px;" src="/120/fr/static/_content/1-sub-2.png">
        <img class="abs halfScale 1-title" style="top:499px;left:54px;" src="/120/fr/static/_content/1-sub-3.png">
        <img id="1-arrow" class="halfScale pointer" style="top:756px;right:-70px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/1-arrow.png">
      `,
      "mobileHtml": `
        <img src="/120/fr/static/_content/1-mobile-1.jpg">
      `,
      "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim
            .staggerFromTo(cOf("1-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
            .fromTo(idOf("1-arrow"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
      
        function onPageLeave() {
          pg1Anim.stop();
        }
      `,
      "searchText": "N˚120 MAGAZINE NUMÉRIQUE  FÉDÉRATION INTERNATIONALE D’ESCRIME  Championnats du monde Juniors et Cadets Coupe du Monde Grand Prix  Utilisez les flèches de votre clavier ou balayez l’écran avec le doigt pour naviguer horizontalement dans le magazine"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 2-title" style="top:79px;left:60px;" src="/120/fr/static/_content/2-title-1.png">
        <img class="abs halfScale pointer howto-desktop" style="top:96px;left:819px;" onclick="switchPopHowto(true)"
          src="/120/fr/static/_content/2-btn-1.png">
        <img class="abs halfScale pointer howto-ipad" style="top:96px;left:973px;opacity:0" onclick="switchPopHowto(false)"
          src="/120/fr/static/_content/2-ipad-btn.png">
        <img class="abs halfScale 2-img howto-desktop" style="top:202px;left:64px;" src="/120/fr/static/_content/2-img-1.png">
        <img class="abs halfScale 2-img howto-ipad" style="top:191px;left:64px; opacity:0" src="/120/fr/static/_content/2-ipad.png">
        <img class="abs halfScaleC 2-text" style="top:607px;left:14px;" src="/120/fr/static/_content/2-text-1.png">
        <img class="abs halfScaleC 2-text" style="top:597px;left:226px;" src="/120/fr/static/_content/2-text-2.png">
        <img class="abs halfScaleC 2-text" style="top:597px;left:496px;" src="/120/fr/static/_content/2-text-3.png">
        <img class="abs halfScaleC 2-text" style="top:597px;left:796px;" src="/120/fr/static/_content/2-text-4.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg2Anim = new TimelineMax();
          pg2Anim
            .staggerFromTo(cOf("2-text"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.3, 1)
        }

        function switchPopHowto(bool){
          if(bool){
            TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:0, onComplete:function(){
              cOf("howto-ipad")[0].style.opacity = 0;
              cOf("howto-ipad")[1].style.display = "none";
            }});
            cOf("howto-desktop")[0].style.opacity = 1;
            cOf("howto-desktop")[1].style.display = "block";
            TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:1});
          }else{
            cOf("howto-ipad")[0].style.opacity = 1;
            cOf("howto-ipad")[1].style.display = "block";
            TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:1});
            TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:0, onComplete:function(){
              cOf("howto-desktop")[0].style.opacity = 0;
              cOf("howto-desktop")[1].style.display = "none";
            }});
          }
        }

        function onPageLeave() {
          pg2Anim.stop();
          resetNumbers("2-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "C OMMENT NAVIGUER  Cliquez pour changer d’affichage  COMMENT NAVIGUER Escrime XXI Le magazine de l’escrime utilise les toutes dernières technologies numériques. Voici quelques-unes de ses caractéristiques les plus séduisantes.  IPAD  BUREAU  SP ORT  COUPE DU MONDE DE SABRE MASCULIN : UN DOUBLÉ EN OR POUR LA HONGRIE À BUDAPEST BUDAPEST, HONGRIE 4–6 MARS 2022  NAVIGATION Utilisez les flèches de votre pavé numérique pour vous déplacer horizontalement à travers le magazine.  Navigation Pour voir le magazine, utilisez les flèches de votre pavé numérique pour naviguer horizontalement.  BROWSER Pour de meilleurs résultats, nous recommandons d’utiliser les navigateurs Safari ou Google Chrome.  EXPLOREZ  térieur ! Des articles passionnants à l’in  1 2 3 FENÊTRES CONTEXTUELLES  BOUTON DE LECTURE  MÉDIAS SOCIAUX  NOMBRES  Appuyez pour faire surgir des trésors d’information.  Ce magazine propose de superbes vidéos, que l’on peut voir en appuyant sur ce bouton.  Appuyez sur les icones des réseaux sociaux que vous rencontrerez tout au long du magazine.  Appuyez sur les boutons pour dévoiler plus de contenus passionnants.  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `
        <a href="https://www.absolutefencinggear.com/" target="_blank" class="contentLinkNone" style="    top: 720px; left: 430px; width: 710px; height: 60px;"></a>
      `,
      "mobileHtml": `
        <a href="https://www.absolutefencinggear.com/" target="_blank">
          <img src="/120/fr/static/_content/3-mobile-1.jpg">
        </a>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 4-title" style="top:47px;left:63px;" src="/120/fr/static/_content/4-title-1.png">
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC abs halfpulse animatedpulse" style="top: 47px; left:644px;" src="/120/fr/static/_content/fb-navy.png">
        </a>
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC abs halfpulse animatedpulse" style="top: 86px; left:644px;" src="/120/fr/static/_content/tw-navy.png">
        </a>
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
        <img id="4-next" class="halfScale pointer" style="top:719px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-pad-sky.png">

          <img class="cont-item cont-item-1-btn halfScale" style="top:251px;left:439px;opacity:0;"
              src="/120/fr/static/_content/4-popup-1-1.png">
          <img class="cont-item cont-item-2-btn halfScale" style="top:259px;left:440px;opacity:0"
            src="/120/fr/static/_content/4-popup-2-1.png">
          <img class="cont-item cont-item-3-btn halfScale" style="top:259px;left:440px;opacity:0"
            src="/120/fr/static/_content/4-popup-2-2.png">
          <img class="cont-item cont-item-4-btn halfScale" style="top:204px;left:440px;opacity:0"
            src="/120/fr/static/_content/4-popup-3-1.png">
          <img class="cont-item cont-item-5-btn halfScale" style="top:269px;left:440px;opacity:0"
            src="/120/fr/static/_content/4-popup-4-1.png">
          <img class="cont-item cont-item-6-btn halfScale" style="top:204px;left:440px;opacity:0"
            src="/120/fr/static/_content/4-popup-5-1.png">
          <img class="cont-item cont-item-7-btn halfScale" style="top:251px;left:440px;opacity:0"
            src="/120/fr/static/_content/4-popup-6-1.png">
          
          <div class="addContentLink" onclick="contentsBub(1);" style="top: 275px; left: 65px; width: 377px; height: 50px;"></div>
          <div class="addContentLink" onclick="contentsBub(2);" style="top: 345px; left: 65px; width: 377px; height: 50px;"></div>
          <div class="contentLinkNone 2-click" onclick="contentsBub(2);"
          style="top: 715px; left: 496px; width: 169px; height: 54px;display:none"></div>
          <div class="contentLinkNone 3-click" onclick="contentsBub(2);"
          style="top: 715px; left: 496px; width: 169px; height: 54px;display:none"></div>
          <div class="contentLinkNone 2-click" onclick="contentsBub(3);"
            style="top: 715px; left: 688px; width: 169px; height: 54px;display:none"></div>
          <div class="contentLinkNone 3-click" onclick="contentsBub(3);"
            style="top: 715px; left: 688px; width: 169px; height: 54px;display:none"></div>
          <div class="addContentLink" onclick="contentsBub(4);" style="top: 415px; left: 65px; width: 377px; height: 50px;"></div>
          <div class="addContentLink" onclick="contentsBub(5);" style="top: 486px; left: 65px; width: 377px; height: 50px;"></div>
          <div class="addContentLink" onclick="contentsBub(6);" style="top: 556px; left: 65px; width: 377px; height: 50px;"></div>
          <div class="addContentLink" onclick="contentsBub(7);" style="top: 626px; left: 65px; width: 377px; height: 50px;"></div>
          
          <div class="contentLink cont-item-1-link" onclick="Publish.goToPage(6)"
            style="top: 273px; left: 442px; width: 594px; height: 50px;display:none;"></div>

          <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(8)"
            style="top: 275px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(10)"
            style="top: 345px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(14)"
            style="top: 415px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(17)"
            style="top: 486px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(20)"
            style="top: 556px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(22)"
            style="top: 626px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(25)"
            style="top: 275px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(27)"
            style="top: 345px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(31)"
            style="top: 415px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(33)"
            style="top: 486px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(35)"
            style="top: 556px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(39)"
            style="top: 626px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          
          <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(45)"
            style="top: 415px; left: 442px; width: 590px; height: 50px;display:none;"></div>
          
          <div class="contentLink cont-item-5-link"
            onclick="Publish.goToPage(47)"
            style="top: 486px; left: 442px; width: 636px; height: 50px;display:none;"></div>
          
          <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(51);setTimeout(function(){showOverlay('51-popups-1'), 1000})"
            style="top: 556px; left: 442px; width: 636px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(51);setTimeout(function(){showOverlay('51-popups-2'), 1000})"
            style="top: 626px; left: 442px; width: 636px; height: 50px;display:none;"></div>
          
          <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-1', '53-cta-1'), 1000})"
            style="top: 275px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-2', '53-cta-2'), 1000})"
            style="top: 345px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-3', '53-cta-3'), 1000})"
            style="top: 415px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-4', '53-cta-4'), 1000})"
            style="top: 486px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-5', '53-cta-5'), 1000})"
            style="top: 556px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-6', '53-cta-6'), 1000})"
            style="top: 626px; left: 442px; width: 594px; height: 50px;display:none;"></div>
      `,
      "script": `
        function onPageEnter() {
          pg4Anim = new TimelineMax();
          pg4Anim
            .fromTo(cOf("4-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(idOf("4-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }

        function contentsBub(index){
          console.log(index)
          for(var i=0; i <= 9; i++){
            if(i == index){
              [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                c.style.display = "";
              },0);
              [].slice.call(cOf(i+"-click")).reduce(function(p,c){
                c.style.display = "";
              },0);
              TweenMax.to(cOf("cont-item-"+i+"-btn"), 0, {opacity:1, onComplete:function(){
                
                cOf("cont-item-"+index+"-link")[0].style.display = ""
                if(cOf("cont-item-"+index+"-link")[1]){
                  cOf("cont-item-"+index+"-link")[1].style.display = "" 
                }
              }});
            }else{
              [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                  c.style.display = "none";
                },0);
              [].slice.call(cOf(i+"-click")).reduce(function(p,c){
                  c.style.display = "none";
                },0);
              TweenMax.to(cOf("cont-item-"+i+"-btn"), 0, {opacity:0});
            }
          }
        }

        function onPageLeave() {
          pg4Anim.stop();
          resetNumbers("4-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SOMMAIRE  DANS CE NUMÉRO  Bienvenue dans la dernière édition d’Escrime XXI, proposant les meilleures images, vidéos et articles sur l’escrime, le tout dans une éblouissante nouvelle maquette.  WWW.FIE.ORG  ÉDITORIAL  SPORT  Cliquez pour faire apparaître les détails  ACTUALITÉS DE LA FIE ACTUALITÉS DES CONFÉDÉRATIONS ET DES FÉDÉRATIONS NATIONAL  N˚120 MAGAZINE NUMÉRIQUE  FÉDÉRATION INTERNATIONALE D’ESCRIME  ACTUALITÉS INTERNATIONALES  Championnats du monde Juniors et Cadets Coupe du Monde Grand Prix  NÉCROLOGIES Utilisez les flèches de votre clavier ou balayez l’écran avec le doigt pour naviguer horizontalement dans le magazine  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `
        <a href="mailto:info@fie.ch">
          <div class="contentLink" style="bottom: 162px; right: 526px; width: 124px; height: 21px;"></div>
        </a>
        <a href="http://www.touchline.com" target="_blank">
          <div class="contentLink" style="bottom: 120px; right: 236px; width: 234px; height: 21px;"></div>
        </a>
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLink" style="bottom: 140px; right: 568px; width: 82px; height: 21px;"></div>
        </a>

        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:785px;left:41px"
            src="/120/fr/static/_content/tw-white.png">
        </a>

        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:785px;left:94px"
            src="/120/fr/static/_content/fb-white.png">
        </a>

        <a href="https://www.youtube.com/user/FIEvideo" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:785px;left:147px"
            src="/120/fr/static/_content/yt-white.png">
        </a>

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>

        <img id="5-next" class="halfScale pointer" style="top:653px;right:-80px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-pad-sky.png">
      `,
      "mobileHtml": `
        <p><strong>Président par interim : </strong><br> Emmanuel Katsiadakis (M.H.) (GRE)
          <br><strong>Secrétaire Trésorier : </strong><br> Ferial Nadira Salhi (ALG)
        </p>
        <p><strong>Vice-Présidents : </strong><br>Erika Aze (LAT)<br>Ana Irene Delgado Guerra (PAN)<br>Abdelmoneim Elhamy El Husseiny (EGY)</p>
        <p><strong>Membres : </strong><br>Rusni Abu Hassan (MAS)<br>Donald Anthony Jr. (USA)<br>Paolo Azzi (ITA)<br>Bruno Gares (FRA)<br>Vadym Guttsait (UKR)<br>Velichka Hristeva (BUL)<br>Yuki Ota (JPN)<br>Novak Perovic (RSA)<br>Oleg Peskov (KAZ)<br>Haibin Wang (CHN)<br>Aldo Montano President of the FIE Athletes’ Commission (ITA)</p>
        <p><strong>Président de la Confédération Africaine d’Escrime : </strong><br> Mbagnick Ndiaye (SEN) <br><strong>Président de la Confédération Panaméricaine d’Escrime : </strong><br> Vitaly Logvin (MEX) <br><strong>Président de la Confédération Asiatique d’Escrime : </strong><br> HH. Engr. Sheikh Salem Sultan S. Al Qasimi (UAE)<br><strong>Président de la Confédération Européenne d’Escrime : </strong><br> Stanislav Pozdnyakov (RUS)
          <br><strong>Président de la Confédération Océanique d’Escrime : </strong><br>  Helen Smith (M.H.) (AUS)
        </p>
        <h2 id="fie-head-office">Siège de la FIE </h2>
        <p><strong>Directrice générale : </strong><br>Nathalie Rodriguez M.-H. (FRA)
        </p>
        <h2 id="administration">Administration</h2>
        <p><strong>Directrice administrative : </strong><br> Elena Murdaca (ITA)<br><strong>Directrice de la comptabilité : </strong><br> Sandra Baroni (SUI)<br><strong>Assistante administrative : </strong><br> Ylenia Murdaca (ITA)<br><strong>Chef de projet : </strong><br> Ekaterina Mashina (RUS)</p>
        <h2 id="sport">Sport</h2>
        <p><strong>Directeur sport et technique : </strong><br>  Evgeny Tsoukhlo (RUS)<br><strong>Manager de la technologie et de l’administration du sport : </strong><br> Natalia Bodrova (RUS)<br><strong>Cheffe des opèrations : </strong><br>  Elena Huot (RUS)</p>
        <h2 id="communication-marketing-tv">Communication, Marketing, TV</h2>
        <p><strong>Chef du cabinet du Président : </strong><br>Nina Lalovic (SRB)<br><strong>Manager digital et communication : </strong><br> Maria Ntanou (GRE)<br><strong>Responsable de la production télévisuelle de la FIE : </strong><br> Barna Heder (HUN) <br><strong>Assistante du responsable de la production télévisuelle de la FIE : </strong><br>  Svetlana Krasnokoutskaya (RUS)<br><strong>Attaché de presse : </strong><br> Serge Timacheff (USA)<br><strong>Photographie : </strong><br> Augusto Bizzi (ITA)</p>
        <h2 id="design">Design  </h2>
        <p>Touchline (www.touchline.com)</p>
      `,
      "script": `
        function onPageEnter() {
          pg5Anim = new TimelineMax();
          pg5Anim
            .fromTo(idOf("5-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg5Anim.stop();
          resetNumbers("5-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "C OMITÉ E XÉCUTIF DE L A FIE  SIÈGE DE LA FIE Directrice générale Nathalie Rodriguez M.-H. (FRA)  Président par interim : Emmanuel Katsiadakis (M.H.) (GRE) Secrétaire Trésorier : Ferial Nadira Salhi (ALG) Vice-Présidents :  Erika Aze (LAT) Ana Irene Delgado Guerra (PAN) Abdelmoneim Elhamy El Husseiny (EGY) Membres :  Rusni Abu Hassan (MAS) Donald Anthony Jr. (USA) Paolo Azzi (ITA) Bruno Gares (FRA) Vadym Guttsait (UKR) Velichka Hristeva (BUL) Yuki Ota (JPN) Novak Perovic (RSA) Oleg Peskov (KAZ) Haibin Wang (CHN) Aldo Montano President of the FIE athletes’ commission (ITA) Président de la Confédération Africaine d’Escrime : Mbagnick Ndiaye (SEN) Président de la Confédération Panaméricaine d’Escrime : Vitaly Logvin (MEX) Président de la Confédération Asiatique d’Escrime : HH. Engr. Sheikh Salem Sultan S. Al Qasimi (UAE) Président de la Confédération Européenne d’Escrime : Stanislav Pozdnyakov (RUS) Président de la Confédération Océanique d’Escrime : Helen Smith (M.H.) (AUS)  Official Publication of the FIE International Fencing Federation Head-office of the FIE Maison du Sport International Avenue de Rhodanie 54 CH-1007 Lausanne  Tél. : +41 21 320 31 15 Fax : +41 21 320 31 16 e-mail : info@fie.ch www.fie.org  Administration Directrice administrative : Elena Murdaca (ITA) Directrice de la comptabilité : Sandra Baroni (SUI) Assistante administrative : Ylenia Murdaca (ITA) Chef de projet : Ekaterina Mashina (RUS) Sport Directeur sport et technique : Evgeny Tsoukhlo (RUS) Manager de la technologie et de l’administration du sport : Natalia Bodrova (RUS) Cheffe des opèrations : Elena Huot (RUS) Communication, Marketing, TV Chef du cabinet du Président : Nina Lalovic (SRB) Manager digital et communication : Maria Ntanou (GRE) Responsable de la production télévisuelle de la FIE : Barna Heder (HUN) Assistante du responsable de la production télévisuelle de la FIE : Svetlana Krasnokoutskaya (RUS) Attaché de presse : Serge Timacheff (USA) Photographie : Augusto Bizzi (ITA) Design Touchline (www.touchline.com)  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `
        <img id="6-img" class="halfScale 6-text-1 6-text" style="top:145px;left:367px"
          src="/120/fr/static/_content/6-img-1.png">
        <img id="6-title" class="halfScale 6-title 6-text-1 6-text" style="top:629px;left:185px"
          src="/120/fr/static/_content/6-title-1.png">
        
        <img id="6-text-1" class="halfScale 6-text-1 6-text" style="top:143px;left:602px"
          src="/120/fr/static/_content/6-text-1.png">
        <img id="6-text-2" class="halfScale 6-text-2 6-text" style="top:143px;left:155px; opacity:0;"
          src="/120/fr/static/_content/6-text-2.png">
        
        <img id="6-cta-1" class="halfScale pointer 6-btn" style="top: 697px; left: 599px;transform: scale(0.505);"
          onclick="toggleText6(false);" src="/120/fr/static/_content/6-btn-1.png">
        <img id="6-cta-2" class="halfScale pointer 6-btn" style="top: 697px; left: 813px;transform: scale(0.505);opacity:0"
          onclick="toggleText6(true);" src="/120/fr/static/_content/6-btn-2.png">

        <img id="6-next" class="halfScale pointer" style="top:719px;right:-80px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-pad-navy.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "mobileHtml": `
        <h2 id="together-we-are-fencing">Ensemble, nous sommes l’escrime</h2>
        <img src="/120/fr/static/_content/6-mobile-1.jpg">
        <p>  <strong>Chers amis,</strong></p>
        <p>Nous sommes heureux de vous présenter cette édition d’Escrime, consacrée à un monde de l’escrime qui est, une fois encore, menacé à l’échelle mondiale. En ces temps extrêmement difficiles, la FIE exprime le souhait que la paix règne de nouveau dans le monde, et nous devons, en tant que famille mondiale, faire preuve de solidarité pour aider ceux qui en ont le plus besoin. Le sport est un outil puissant en faveur de la paix, de la réconciliation et de la compréhension pour unir les gens. Nous pouvons et devons vivre pacifiquement. 
        </p>
        <p>Nous avons également dû faire face à la pandémie mondiale au cours des deux dernières années. Pendant cette période, la FIE et ses fédérations internationales ont travaillé pour que nos compétitions puissent se dérouler en assurant un niveau de sécurité le plus élevé possible. Les tournois du Grand Prix et de la Coupe du monde ont ainsi repris avec succès, et se poursuivront tout au long de l’année, avec encore de nombreuses compétitions à venir. Les Championnats du monde d’escrime juniors et cadets 2022 à Dubaï viennent par ailleurs de se terminer. Au total, 1 357 tireurs de 103 pays, soit la participation la plus importante de notre histoire, se sont retrouvés pour neuf jours de compétition pacifiques et passionnants. </p>
        <p> Les Championnats du monde d’escrime seniors seront ensuite organisés en Égypte en juillet, et la Croatie accueillera les Championnats du monde d’escrime vétérans en octobre. </p>
        <p>Suite au succès retentissant de l’escrime aux Jeux Olympiques de Tokyo 2020, je considère que nous sommes dans une position plus forte que jamais pour continuer à appliquer notre stratégie afin de développer et d’augmenter encore la popularité de notre sport, avec en ligne de mire les prochains Jeux Olympiques de Paris 2024. La croissance remarquable de l’escrime sur les médias sociaux, à la télévision et au niveau de la participation mondiale, montre clairement que nous sommes sur le bon chemin pour développer encore notre sport.</p>
        <p>Le temps est maintenant venu de nous montrer ingénieux et innovants pour renforcer l’escrime à plusieurs niveaux, afin de susciter l’engouement et de mieux faire connaître notre sport dans le monde. Nous devons continuer sur la lancée des années passées pour évoluer encore avec force, enthousiasme et optimisme.  </p>
        <p>Je vous invite tous à jouer vos rôles d’ambassadeurs et d’acteurs de notre sport pour devenir encore plus forts et importants, à la fois dans vos communautés et dans vos salles d’escrime. Que vous soyez athlète, entraîneur, officiel, bénévole ou supporter, chacun de vous joue un rôle extrêmement important dans le succès de l’escrime mondiale, un rôle qu’on ne soulignera simplement jamais assez. </p><p>Au nom de la FIE, j’aimerais vous remercier de votre soutien constant, et j’espère que l’année 2022 vous apporte santé et prospérité.</p>
        <p>Emmanuel Katsiadakis<br><strong>Président par interim</strong></p>
      `,
      "script": `
        function onPageEnter() {
          pg6Anim = new TimelineMax();
          pg6Anim
            .fromTo(cOf("6-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(idOf("6-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }

        function toggleText6(bool){
          var text1 = idOf("6-text-1");
          var text2 = idOf("6-text-2");
          
          if(!bool && text1.style.opacity == "0"){
            pg6Anim.play();
            TweenMax.fromTo(text1, 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(text2, 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("6-cta-1"), 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("6-cta-2"), 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("6-img"), 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("6-title"), 0.5, {opacity:0}, {opacity:1});
          }else if(bool && text2.style.opacity == "0"){
            pg6Anim.pause();
            TweenMax.fromTo(text1, 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(text2, 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("6-cta-1"), 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("6-cta-2"), 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("6-img"), 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("6-title"), 0.5, {opacity:1}, {opacity:0});
          }
        }

        function onPageLeave() {
          toggleText6(false)
          pg6Anim.stop();
          resetNumbers("6-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "ÉDITORIAL  Chers amis, Nous sommes heureux de vous présenter cette édition d’Escrime, consacrée à un monde de l’escrime qui est, une fois encore, menacé à l’échelle mondiale. En ces temps extrêmement difficiles, la FIE exprime le souhait que la paix règne de nouveau dans le monde, et nous devons, en tant que famille mondiale, faire preuve de solidarité pour aider ceux qui en ont le plus besoin. Le sport est un outil puissant en faveur de la paix, de la réconciliation et de la compréhension pour unir les gens. Nous pouvons et devons vivre pacifiquement.  ENSEMBLE, NOUS SOMMES L’ESCRIME  Nous avons également dû faire face à la pandémie mondiale au cours des deux dernières années. Pendant cette période, la FIE et ses fédérations internationales ont travaillé pour que nos compétitions puissent se dérouler en assurant un niveau de sécurité le plus élevé possible. Les tournois du Grand Prix et de la Coupe du monde ont ainsi repris avec succès, et se poursuivront  PAGE 1  PAGE 2  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `
        <a href="https://shop.pbtfencing.com/" target="_blank">
          <div class="contentLinkNone" style="bottom: 21px; right: 723px; width: 193px; height: 38px;"></div>
        </a>
        <a href="mailto:sales@pbtfencing.com" target="_blank">
          <div class="contentLinkNone" style="bottom:21px;right:505px;width:205px;height:38px;"></div>
        </a>
        <a href="https://www.instagram.com/pbt_fencing" target="_blank">
          <div class="contentLinkNone" style="bottom: 21px; right: 259px; width: 236px; height: 38px;"></div>
        </a>
      `,
      "mobileHtml": `
        <a href="https://shop.pbtfencing.com/" target="_blank">
          <img src="/120/fr/static/_content/7-mobile-1.jpg">
        </a>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 8-title" style="top:116px;left:65px;" src="/120/fr/static/_content/8-title-1.png">
        <img class="abs halfScale 8-sub" style="top:364px;left:97px;" src="/120/fr/static/_content/8-sub-1.png">
        <img class="abs halfScale 8-line" style="top:366px;left:64px;" src="/120/fr/static/_content/8-line-1.png">
        <img id="8-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2
          id="usa-s-gassner-italy-s-cammilletti-win-tashkent-satellite-foil-tournament">L'Américain Gassner et l'Italienne Cammilletti remportent le tournoi satellite de fleuret de Tachkent  </h2>
        <img src="/120/fr/static/_content/8-mobile-1.jpg">
        <p><strong>Tachkent, Ouzbékistan<br>29 Septembre 2021</strong></p>
        <p><strong>​​L'Américain Ethan Gassner et l'Italienne Marta Cammilletti ont décroché les médailles d'or du tournoi international satellite de fleuret organisé à Tachkent, Ouzbékistan, les 25 et 26 septembre. </strong></p>
        <p>De nombreux pays étaient représentés par les quarante-huit athlètes en lice, à savoir la Biélorussie, l'Iran, l'Irak, l'Italie, le Kazakhstan, les Philippines, la Turquie, les États-Unis et l'Ouzbékistan. </p>
        <p>Gassner s'est imposé en finale du fleuret masculin face au Biélorusse Uladzislau Kurylovich (15-10). Les médailles de bronze sont revenues à Akhmadillokhon Solikhojiev (UZB) et Mukhammad Yusuf Asranov (UZB). </p>
        <p>Au fleuret féminin, Cammilletti a remporté la finale face à la Philippine Maxine Isabel Esteban (15-2). Madinabonu Parpieva (UZB) et Umida Ilyosova (UZB) ont décroché le bronze. </p>
        <p>La compétition a été organisée conformément aux règlements de la FIE et au protocole relatif à la COVID-19..</p>
      `,
      "script": `
        function onPageEnter() {
          pg8Anim = new TimelineMax();
          pg8Anim
            .fromTo(cOf("8-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("8-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("8-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("8-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }

        function onPageLeave() {
          pg8Anim.stop();
          resetNumbers("8-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  L'AMÉRICAIN GASSNER ET L'ITALIENNE CAMMILLETTI REMPORTENT LE TOURNOI SATELLITE DE FLEURET DE TACHKENT TACHKENT, OUZBÉKISTAN 29 SEPTEMBRE 2021"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-red.png">
        </a>

        <img id="9-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg9Anim = new TimelineMax();
          pg9Anim
            .fromTo(idOf("9-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }

        function onPageLeave() {
          pg9Anim.stop();
          resetNumbers("9-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "TOURNOI SATELLITE DE FLEURET TACHKENT, OUZBÉKISTAN, 2/2  L'Américain Ethan Gassner et l'Italienne Marta Cammilletti ont décroché les médailles d'or du tournoi international satellite de fleuret organisé à Tachkent, Ouzbékistan, les 25 et 26 septembre. De nombreux pays étaient représentés par les quarante-huit athlètes en lice, à savoir la Biélorussie, l'Iran, l'Irak, l'Italie, le Kazakhstan, les Philippines, la Turquie, les États-Unis et l'Ouzbékistan. Gassner s'est imposé en finale du fleuret masculin face au Biélorusse Uladzislau Kurylovich (15-10). Les médailles de bronze sont revenues à Akhmadillokhon Solikhojiev (UZB) et Mukhammad Yusuf Asranov (UZB). Au fleuret féminin, Cammilletti a remporté la finale face à la Philippine Maxine Isabel Esteban (15-2). Madinabonu Parpieva (UZB) et Umida Ilyosova (UZB) ont décroché le bronze. La compétition a été organisée conformément aux règlements de la FIE et au protocole relatif à la COVID-19. ■ W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 10-title" style="top:102px;left:411px;" src="/120/fr/static/_content/10-title-1.png">
        <img class="abs halfScale 10-sub" style="top:300px;left:443px;" src="/120/fr/static/_content/10-sub-1.png">
        <img class="abs halfScale 10-line" style="top:303px;left:410px;" src="/120/fr/static/_content/10-line-1.png">
        <img id="10-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2 id="korea-s-kim-greece-s-georgiadou-win-2021-orleans-sabre-grand-prix">L'or pour le Coréen Junghwan Kim et la Grecque Despina Georgiadou au Grand Prix de sabre d'Orléans 2021</h2>
        <img src="/120/fr/static/_content/10-mobile-1.jpg">
        <p><strong>Orléans, France<br>13 Novembre 2021</strong></p>
        <p><strong>Le Grand Prix de sabre d'Orléans, premier Grand Prix de la FIE de la saison de compétition 2021-2022, a été remporté par le champion du monde coréen Junghwan Kim et la Grecque Despina Georgiadou. La compétition, organisée au Zénith d'Orléans, a été disputée par 170 tireurs et 162 tireuses. </strong></p>
        <p>Junghwan Kim a décroché l'or du sabre masculin en terrassant en finale l'Italien Luca Curatoli (15-3). En demi-finale, Curatoli avait fait chuter le Japonais Kento Yoshida (15-10), et Kim avait éliminé son coéquipier, le champion du monde Sanguk Oh (15-13).</p>
        <p>La finale du sabre féminin a été remportée sur le fil par Despina Georgiadou face à sa coéquipière Theodora Gkountoura (15-14). En demi-finale, Gkountoura avait sorti la Coréenne Jisu Yoon (15-12), et Georgiadou avait évincé la Russe Svetlana Sheveleva (15-12). Yoon avait notamment éliminé en quart de finale une autre Coréenne, la championne olympique Jiyeon Kim (15-13).</p>
        <p>Les huit premiers au classement du sabre masculin sont Junghwan Kim (KOR, or), Luca Curatoli (ITA, argent), Sanguk Oh (KOR, bronze), Kento Yoshida (JPN, bronze), Sandro Bazadze (GEO), Junho Kim (KOR), Andriy Yagodka (UKR) et Enver Yildirim (TUR)./p>
        <p>Les huit premières au classement du sabre féminin sont Despina Georgiadou (GRE, or), Theodora Gkountoura (GRE, argent), Svetlana Sheveleva (RUS, bronze), Jisu Yoon (KOR, bronze), Manon Apithy-Brunet (FRA), Liza Pusztai (HUN), Jiyeon Kim (KOR) et Amalia Aime (FRA).</p>
        <p>Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la série de vidéos de la FIE sur notre chaîne YouTube.</p>
        <p>Pour revivre les matches des tournois masculin et féminin du Grand Prix de sabre d'Orléans, cliquez ici..</p>
      `,
      "script": `
        function onPageEnter() {
          pg10Anim = new TimelineMax();
          pg10Anim
            .fromTo(cOf("10-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("10-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("10-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("10-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
        
        function onPageLeave() {
          pg10Anim.stop();
          resetNumbers("10-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  L'OR POUR LE CORÉEN JUNGHWAN KIM ET LA GRECQUE DESPINA GEORGIADOU AU GRAND PRIX DE SABRE D'ORLÉANS 2021 ORLÉANS, FRANCE 13 NOVEMBRE 2021"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-red.png">
        </a>

        <img id="11-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg11Anim = new TimelineMax();
          pg11Anim
            .fromTo(idOf("11-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg11Anim.stop();
          resetNumbers("11-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "GRAND PRIX DE SABRE ORLÉANS, FRANCE 2/3  Le Grand Prix de sabre d'Orléans, premier Grand Prix de la FIE de la saison de compétition 2021-2022, a été remporté par le champion du monde coréen Junghwan Kim et la Grecque Despina Georgiadou. La compétition, organisée au Zénith d'Orléans, a été disputée par 170 tireurs et 162 tireuses. Junghwan Kim a décroché l'or du sabre masculin en terrassant en finale l'Italien Luca Curatoli (15-3). En demi-finale, Curatoli avait fait chuter le Japonais Kento Yoshida (15-10), et Kim avait éliminé son coéquipier, le champion du monde Sanguk Oh (15-13). La finale du sabre féminin a été remportée sur le fil par Despina Georgiadou face à sa coéquipière Theodora Gkountoura (15-14). En demi-finale, Gkountoura avait sorti la Coréenne Jisu Yoon (15-12), et Georgiadou avait évincé la Russe Svetlana Sheveleva (15-12). Yoon avait notamment éliminé en quart de finale une autre Coréenne, la championne olympique Jiyeon Kim (15-13). Les huit premiers au classement du sabre masculin sont Junghwan Kim (KOR, or),"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-red.png">
        </a>
        
        <a href="https://fie.org/competitions/2022/158" target="_blank">
          <div class="addContentLink" style="bottom: 60px; right: 557px; width: 215px; height: 20px;"></div>
          <div class="addContentLink" style="bottom: 389px; right: 434px; width: 93px; height: 21px;"></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink" style="bottom: 342px; right: 245px; width: 132px; height: 21px;"></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo/videos" target="_blank">
          <div class="addContentLink" style="bottom: 247px; right: 438px; width: 88px; height: 21px;"></div>
        </a>

        <img id="12-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg12Anim = new TimelineMax();
          pg12Anim
            .fromTo(idOf("12-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg12Anim.stop();
          resetNumbers("12-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "GRAND PRIX DE SABRE ORLÉANS, FRANCE 3/3  Luca Curatoli (ITA, argent), Sanguk Oh (KOR, bronze), Kento Yoshida (JPN, bronze), Sandro Bazadze (GEO), Junho Kim (KOR), Andriy Yagodka (UKR) et Enver Yildirim (TUR). Les huit premières au classement du sabre féminin sont Despina Georgiadou (GRE, or), Theodora Gkountoura (GRE, argent), Svetlana Sheveleva (RUS, bronze), Jisu Yoon (KOR, bronze), Manon Apithy-Brunet (FRA), Liza Pusztai (HUN), Jiyeon Kim (KOR) et Amalia Aime (FRA).  cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la série de vidéos de la FIE sur notre chaîne YouTube. Pour revivre les matches des tournois masculin et féminin du Grand Prix de sabre d'Orléans, cliquez ici. ■  Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `
        <a href="mailto:lammet@mail.ru" target="_blank">
          <div class="contentLinkNone" style="bottom: 317px; right: 113px; width: 197px; height: 24px;"></div> </a>
        <a href="https://www.lammet.ru" target="_blank">
          <div class="contentLinkNone" style="bottom: 292px; right: 177px; width: 132px; height: 24px;"></div> </a>
      `,
      "mobileHtml": `
        <a href="https://www.lammet.ru" target="_blank">
          <img src="/120/fr/static/_content/13-mobile-1.jpg">
        </a>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 14-title" style="top:62px;left:61px;" src="/120/fr/static/_content/14-title-1.png">
        <img class="abs halfScale 14-sub" style="top:260px;left:97px;" src="/120/fr/static/_content/14-sub-1.png">
        <img class="abs halfScale 14-line" style="top:257px;left:64px;" src="/120/fr/static/_content/14-line-1.png">
        <img id="14-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2
          id="france-s-jacques-andre-coquin-and-team-russia-win-glaive-de-tallinn-women-s-epee-world-cup">​​Coupe du monde d'épée féminine : la Française Joséphine Jacques-André-Coquin et l'équipe de Russie remportent le « Glaive de Tallinn »</h2>
        <img src="/120/fr/static/_content/14-mobile-1.jpg">
        <p><strong>Tallinn, Estonie<br>19-21 Nov. 2021</strong></p>
        <p>La Française Joséphine Jacques-André-Coquin a remporté le titre individuel de la 51ème édition du « Glaive de Tallinn » de la Coupe du monde d'épée féminine. L'équipe de Russie est repartie avec l'or de l'épreuve par équipes. </p>
        <p>Cette première étape de la Coupe du monde féminine senior de la FIE de la saison de compétitions 2021-2022, organisée au Kalev Sports Hall, a été disputée par 246 épéistes et 26 équipes.</p>
        <p>Joséphine Jacques-André-Coquin a remporté l'or de l'épée individuelle en s'imposant en finale face à sa coéquipière Marie-Florence Candassamy sur le score de 15-11. En demi-finale, Candassamy avait battu l'Italienne Federica Isola (15-9) et Jacques-André-Coquin avait éliminé sa coéquipière Alexandra Louis Marie (15-11).</p>
        <p>La Russie a remporté la finale de l'épreuve par équipes face à l'Allemagne (43-37). En demi-finale, l'Allemagne avait battu l'Italie (32-31) et la Russie avait éliminé la Corée (45-35). L'Italie a par la suite décroché la médaille de bronze au détriment de la Corée (45-33).</p>
        <p>Les huit premières au classement final de l'épée individuelle sont Joséphine Jacques-André-Coquin (FRA, or), Marie-Florence Candassamy (FRA, argent), Federica Isola (ITA, bronze), Alexandra Louis Marie (FRA, bronze), Renata Knapik-Miazga (POL), Aliya Luty (FRA), Anna Van Brummen (USA) et Lauren Rembi (FRA).</p>
        <p>Au classement final de l'épreuve par équipes, la Russie arrive en tête (or), suivie de l'Allemagne (argent), l'Italie (bronze), la Corée, l'Estonie, la Suisse, la France et la Pologne.</p>
        <p>Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la série de vidéos de la FIE sur la chaîne YouTube de la FIE.</p>
      `,
      "script": `
        function onPageEnter() {
          pg14Anim = new TimelineMax();
          pg14Anim
            .fromTo(cOf("14-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("14-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("14-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("14-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
        
        function onPageLeave() {
          pg14Anim.stop();
          resetNumbers("14-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  COUPE DU MONDE D'ÉPÉE FÉMININE : LA FRANÇAISE JOSÉPHINE JACQUESANDRÉ-COQUIN ET L'ÉQUIPE DE RUSSIE REMPORTENT LE « GLAIVE DE TALLINN » TALLINN, ESTONIE 19-21 NOV. 2021"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-red.png">
        </a>

        <img id="15-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg15Anim = new TimelineMax();
          pg15Anim
            .fromTo(idOf("15-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg15Anim.stop();
          resetNumbers("15-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "COUPE DU MONDE D'ÉPÉE FÉMININE TALLINN, ESTONIE 2/3  La Française Joséphine JacquesAndré-Coquin a remporté le titre individuel de la 51ème édition du « Glaive de Tallinn » de la Coupe du monde d'épée féminine. L'équipe de Russie est repartie avec l'or de l'épreuve par équipes. Cette première étape de la Coupe du monde féminine senior de la FIE de la saison de compétitions 2021-2022, organisée au Kalev Sports Hall, a été disputée par 246 épéistes et 26 équipes.  Joséphine Jacques-André-Coquin a remporté l'or de l'épée individuelle en s'imposant en finale face à sa coéquipière Marie-Florence Candassamy sur le score de 15-11. En demifinale, Candassamy avait battu l'Italienne Federica Isola (15-9) et Jacques-André-Coquin avait éliminé sa coéquipière Alexandra Louis Marie (15-11). La Russie a remporté la finale de l'épreuve par équipes face à l'Allemagne (43-37). En demifinale, l'Allemagne avait battu l'Italie (32-31) et la Russie avait éliminé la Corée (45-35). L'Italie"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-red.png">
        </a>
        
        <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="bottom: 295px; right: 433px; width: 94px; height: 20px;"></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink"
            style="bottom: 249px; right: 200px; width: 208px; height: 20px;"></div>
        </a>

        <img id="16-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg16Anim = new TimelineMax();
          pg16Anim
            .fromTo(idOf("16-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg16Anim.stop();
          resetNumbers("16-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "COUPE DU MONDE D'ÉPÉE FÉMININE TALLINN, ESTONIE 3/3  a par la suite décroché la médaille de bronze au détriment de la Corée (45-33). Les huit premières au classement final de l'épée individuelle sont Joséphine Jacques-AndréCoquin (FRA, or), Marie-Florence Candassamy (FRA, argent), Federica Isola (ITA, bronze), Alexandra Louis Marie (FRA, bronze), Renata Knapik-Miazga (POL), Aliya Luty (FRA), Anna Van Brummen (USA) et Lauren Rembi (FRA). Au classement final de l'épreuve par équipes, la Russie arrive en tête (or), suivie de l'Allemagne (argent), l'Italie (bronze), la Corée, l'Estonie, la Suisse, la France et la Pologne. Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la série de vidéos de la FIE sur la chaîne YouTube de la FIE. ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg17.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 17-title" style="top:74px;left:66px;" src="/120/fr/static/_content/17-title-1.png">
        <img class="abs halfScale 17-sub" style="top:235px;left:97px;" src="/120/fr/static/_content/17-sub-1.png">
        <img class="abs halfScale 17-line" style="top:233px;left:64px;" src="/120/fr/static/_content/17-line-1.png">
        <img id="17-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2 id="venezuela-s-limardo-gascon-team-russia-win-bern-men-s-epee-world-cup">Coupe du monde d'épée masculine : l'or pour le Vénézuélien Limardo Gascon et l'équipe de Russie</h2>
        <img src="/120/fr/static/_content/17-mobile-1.jpg">
        <p>​​<strong>Bern, Suisse<br>19-21 Novembre 2021</strong></p>
        <p><strong>Le champion olympique vénézuélien Ruben Limardo Gascon a remporté le titre individuel de la Coupe du monde d'épée masculine de Bern.   </strong></p>
        <p>L'équipe de Russie est repartie avec l'or de l'épreuve par équipes. Cette première étape de la Coupe du monde masculine senior de la FIE de la saison de compétitions 2021-2022 a été disputée par 265 épéistes et 33 équipes. La compétition s'est déroulée dans le Sporthalle Wankdorf de Berne.</p>
        <p>Limardo Gascon a remporté l'or de l'épée individuelle en s'imposant en finale face au Français Alexandre Bardenet sur le score de 15-7. En demi-finale, Bardenet avait sorti l'un de ses coéquipiers, le champion olympique Romain Cannone (15-9), et Limardo Gascon avait éliminé sur le fil l'Italien Andrea Santarelli (10-9). En quart de finale, Bardenet avait également dû affronter un autre membre de l'équipe de France, le champion du monde Yannick Borel, battu 15 touches à 9.</p>
        <p>Les Russes ont ravi le titre par équipes à des Espagnols combatifs qui n'ont concédé la victoire en finale que d'une petite touche (45-44). En demi-finale, l'Espagne avait dominé la Hongrie (45-42) et la Russie avait éliminé le Japon (45-34). Le Japon est reparti avec la médaille de bronze après une victoire sur la Hongrie (45-34).</p>
        <p>Les huit premiers au classement final de l'épreuve individuelle sont Ruben Limardo Gascon (VEN, or), Alexandre Bardenet (FRA, argent), Romain Cannone (FRA, bronze), Andrea Santarelli (ITA, bronze), Daniel Berta (HUN), Koki Kano (JPN), Alex Fava (FRA) et Georgiy Bruev (RUS).</p>
        <p>Au classement final de l'épreuve par équipes, la Russie arrive en tête (or), suivie de l'Espagne (argent), du Japon (bronze), de la Hongrie, de la France, de l'Ukraine, du Danemark et de l'Italie.</p>
      `,
      "script": `
        function onPageEnter() {
          pg17Anim = new TimelineMax();
          pg17Anim
            .fromTo(cOf("17-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("17-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("17-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("17-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
        
        function onPageLeave() {
          pg17Anim.stop();
          resetNumbers("17-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  COUPE DU MONDE D'ÉPÉE MASCULINE : L'OR POUR LE VÉNÉZUÉLIEN LIMARDO GASCON ET L'ÉQUIPE DE RUSSIE BERN, SUISSE 19-21 NOVEMBRE 2021"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg18.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-red.png">
        </a>

        <img id="18-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg18Anim = new TimelineMax();
          pg18Anim
            .fromTo(idOf("18-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg18Anim.stop();
          resetNumbers("18-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "COUPE DU MONDE D'ÉPÉE MASCULINE BERN, SUISSE 2/2  Le champion olympique vénézuélien Ruben Limardo Gascon a remporté le titre individuel de la Coupe du monde d'épée masculine de Bern. L'équipe de Russie est repartie avec l'or de l'épreuve par équipes. Cette première étape de la Coupe du monde masculine senior de la FIE de la saison de compétitions 2021-2022 a été disputée par 265 épéistes et 33 équipes. La compétition s'est déroulée dans le Sporthalle Wankdorf de Berne. Limardo Gascon a remporté l'or de l'épée individuelle en s'imposant en finale face au Français Alexandre Bardenet sur le score de 15-  7. En demi-finale, Bardenet avait sorti l'un de ses coéquipiers, le champion olympique Romain Cannone (15-9), et Limardo Gascon avait éliminé sur le fil l'Italien Andrea Santarelli (109). En quart de finale, Bardenet avait également dû affronter un autre membre de l'équipe de France, le champion du monde Yannick Borel, battu 15 touches à 9. Les Russes ont ravi le titre par équipes à des Espagnols combatifs qui n'ont concédé la victoire en finale que d'une petite touche (45-44). En demi-finale, l'Espagne avait dominé la Hongrie (45-42) et la Russie avait éliminé le Japon (4534). Le Japon est reparti avec la médaille de bronze après une victoire sur la Hongrie (45-34). Les huit premiers au classement final de l'épreuve individuelle sont Ruben Limardo Gascon (VEN, or), Alexandre Bardenet (FRA, argent), Romain Cannone (FRA, bronze), Andrea Santarelli (ITA, bronze), Daniel Berta (HUN), Koki Kano (JPN), Alex Fava (FRA) et Georgiy Bruev (RUS). Au classement final de l'épreuve par équipes, la Russie arrive en tête (or), suivie de l'Espagne (argent), du Japon (bronze), de la Hongrie, de la France, de l'Ukraine, du Danemark et de l'Italie. ■ W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg19.jpg",
      "zoom": null,
      "content": ``,
      "mobileHtml": `
        <img src="/120/fr/static/_content/19-mobile-1.jpg">
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 19,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg20.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 20-title" style="top:56px;left:453px;" src="/120/fr/static/_content/20-title-1.png">
        <img class="abs halfScale 20-sub" style="top:218px;left:485px;" src="/120/fr/static/_content/20-sub-1.png">
        <img class="abs halfScale 20-line" style="top:220px;left:453px;" src="/120/fr/static/_content/20-line-1.png">
        <img id="20-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2
          id="italy-s-alice-volpi-and-team-italy-win-gold-at-st-maur-women-s-foil-world-cup">Un doublé en or pour l'Italie à la Coupe du monde de fleuret féminin à Saint-Maur</h2>
        <img src="/120/fr/static/_content/20-mobile-1.jpg">
        <p><strong>Saint-Maur-des-Fossés, France<br>12 Décembre 2021</strong></p>
        <p><strong>La championne du monde italienne Alice Volpi a remporté l'or de l'épreuve individuelle de la Coupe du monde de fleuret féminin de Saint-Maur, avant de remonter sur la plus haute marche du podium aux côtés de ses coéquipières de l'équipe nationale italienne à l'issue de l'épreuve par équipes. </strong></p>
        <p>La compétition, organisée au Centre sportif Pierre Brossolette, a été disputée par 182 fleurettistes et 20 équipes.</p>
        <p>Alice Volpi a remporté la finale de l'épreuve de fleuret individuel à la touche en or face à la championne olympique américaine Lee Kiefer (15-14). En demi-finale, Kiefer n'avait fait qu'une bouchée de sa coéquipière Jacqueline Dubrovich (15-4), Volpi éliminant quant à elle sa coéquipière Francesca Palumbo (15-12).</p>
        <p>L'Italie a remporté la finale de l'épreuve de fleuret féminin par équipes face au Japon sur le score de 43-40. En demi-finale, le Japon avait éliminé la Russie (31-26), et l'Italie s'était imposée face au Canada (45-37). La médaille de bronze est revenue aux Russes après une victoire serrée en petite finale face aux Canadiennes (44-39).</p>
        <p>Les huit premières au classement de l'épreuve individuelle de fleuret féminin de la Coupe du monde de Saint-Maur sont Alice Volpi (ITA, or), Lee Kiefer (USA, argent), Jacqueline Dubrovich (USA, bronze), Francesca Palumbo (ITA, bronze), Qingyuan Chen (CHN), Martina Batini (ITA), Svetlana Tripapina (RUS) et Kiyeun Kim (KOR).</p>
        <p>Au classement de l'épreuve de fleuret féminin par équipes, l'Italie arrive en tête (or), suivie du Japon (argent), de la Russie (bronze), du Canada, de la Pologne, de la Chine, des États-Unis et de Hong Kong.</p>
        <p>Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la chaîne YouTube de la FIE.</p>
      `,
      "script": `
        function onPageEnter() {
          pg20Anim = new TimelineMax();
          pg20Anim
            .fromTo(cOf("20-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("20-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("20-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("20-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
        
        function onPageLeave() {
          pg20Anim.stop();
          resetNumbers("20-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  UN DOUBLÉ EN OR POUR L'ITALIE À LA COUPE DU MONDE DE FLEURET FÉMININ À SAINT-MAUR SAINT-MAUR-DES-FOSSÉS, FRANCE 12 DÉCEMBRE 2021"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 20,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg21.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-red.png">
        </a>
        
        <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="  bottom: 108px; right: 425px; width: 102px; height: 20px; "></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink"
            style="bottom: 83px; right: 151px; width: 57px; height: 20px;"></div>
          <div class="addContentLink"
            style="bottom: 61px; right: 375px; width: 152px; height: 20px;"></div>
        </a>

        <img id="21-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg21Anim = new TimelineMax();
          pg21Anim
            .fromTo(idOf("21-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg21Anim.stop();
          resetNumbers("21-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "COUPE DU MONDE DE FLEURET FÉMININ SAINT-MAUR-DESFOSSÉS, FRANCE 2/2  La championne du monde italienne Alice Volpi a remporté l'or de l'épreuve individuelle de la Coupe du monde de fleuret féminin de Saint-Maur, avant de remonter sur la plus haute marche du podium aux côtés de ses coéquipières de l'équipe nationale italienne à l'issue de l'épreuve par équipes. La compétition, organisée au Centre sportif Pierre Brossolette, a été disputée par 182 fleurettistes et 20 équipes. Alice Volpi a remporté la finale de l'épreuve de fleuret individuel à la touche en or face à la championne olympique américaine Lee Kiefer (15-14). En demi-finale, Kiefer n'avait fait qu'une bouchée de sa coéquipière Jacqueline Dubrovich (15-4), Volpi éliminant quant à elle sa coéquipière Francesca Palumbo (15-12). L'Italie a remporté la finale de l'épreuve de fleuret féminin par équipes face au Japon sur le score de 43-40. En demi-finale, le Japon avait éliminé la Russie (31-26), et l'Italie s'était imposée face au Canada (45-37). La médaille de bronze est revenue aux Russes après une victoire serrée en petite finale face aux Canadiennes (44-39).  Les huit premières au classement de l'épreuve individuelle de fleuret féminin de la Coupe du monde de Saint-Maur sont Alice Volpi (ITA, or), Lee Kiefer (USA, argent), Jacqueline Dubrovich (USA, bronze), Francesca Palumbo (ITA, bronze), Qingyuan Chen (CHN), Martina Batini (ITA), Svetlana Tripapina (RUS) et Kiyeun Kim (KOR). Au classement de l'épreuve de fleuret féminin par équipes, l'Italie arrive en tête (or), suivie du Japon (argent), de la Russie (bronze), du Canada, de la Pologne, de la Chine, des ÉtatsUnis et de Hong Kong. Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la chaîne YouTube de la FIE. ■ W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 21,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg22.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 22-title" style="top:64px;left:332px;" src="/120/fr/static/_content/22-title-1.png">
        <img class="abs halfScale 22-sub" style="top:308px;left:364px;" src="/120/fr/static/_content/22-sub-1.png">
        <img class="abs halfScale 22-line" style="top:306px;left:332px;" src="/120/fr/static/_content/22-line-1.png">
        <img id="22-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2
          id="hong-kong-s-cheung-team-italy-take-gold-in-challenge-international-de-paris-men-s-foil-world-cup">Le Hongkongais Cheung et l'équipe d'Italie couronnés d'or au Challenge International de Paris de la Coupe du monde de fleuret masculin</h2>
        <img src="/120/fr/static/_content/22-mobile-1.jpg">
        <p><strong>Paris, France<br>14-16 Janvier 2022</strong></p>
        <p><strong>Le champion olympique hongkongais Ka Long Cheung a remporté le titre individuel du Challenge International de Paris de la Coupe du monde de fleuret masculin.  </strong></p>
        <p>L'équipe d'Italie est repartie avec l'or de l'épreuve par équipes. La compétition, qui s'est déroulée au stade Pierre de Coubertin, a attiré 210 fleurettistes et 26 équipes.</p>
        <p>En finale du fleuret individuel, Cheung a battu l'Italien Edoardo Luperi sur le score de 15 touches à 12. En demi-finale, Luperi avait éliminé l'Américain Chase Emmer (15-13) et Cheung avait terrassé le champion du monde italien Alessio Foconi (15-4). En quart de finale, Cheung avait également mis fin au parcours du champion du monde français Enzo Lefort (15-9), et Emmer avait sorti le champion olympique italien Daniele Garozzo (15-5).</p>
        <p>L'Italie a remporté l'or de l'épreuve de fleuret par équipes en s'imposant en finale face à la France (45-20). En demi-finale, la France avait éliminé la Russie (45-39) et l'Italie avait fait chuter les États-Unis (45-38). Les Américains ont remporté la médaille de bronze en battant les Russes 45 touches à 31.</p>
        <p>Les huit premiers au classement final du fleuret individuel sont Ka Long Cheung (HKG, or), Edoardo Luperi (ITA, argent), Chase Emmer (USA, bronze), Alessio Foconi (ITA, bronze), Daniele Garozzo (ITA), Chun Yin Ryan Choi (HKG), Enzo Lefort (FRA) et Alexandre Sido (FRA).</p>
        <p>Au classement final de l'épreuve de fleuret par équipes, l'Italie arrive en tête (or), suivie de la France (argent), des États-Unis (bronze), de la Russie, du Japon, de l'Égypte, de la Corée et de Hong Kong.</p>
        <p>Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la chaîne YouTube de la FIE.</p>
      `,
      "script": `
        function onPageEnter() {
          pg22Anim = new TimelineMax();
          pg22Anim
            .fromTo(cOf("22-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("22-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("22-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("22-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
        
        function onPageLeave() {
          pg22Anim.stop();
          resetNumbers("22-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  LE HONGKONGAIS CHEUNG ET L'ÉQUIPE D'ITALIE COURONNÉS D'OR AU CHALLENGE INTERNATIONAL DE PARIS DE LA COUPE DU MONDE DE FLEURET MASCULIN PARIS, FRANCE 14-16 JANVIER 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 22,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg23.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-red.png">
        </a>
        
        <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="bottom: 131px; right: 177px; width: 192px; height: 20px;"></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink" style="bottom: 84px; right: 150px; width: 59px; height: 20px;"></div>
          <div class="addContentLink" style="bottom: 60px; right: 375px; width: 151px; height: 20px;"></div>
        </a>

        <img id="23-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg23Anim = new TimelineMax();
          pg23Anim
            .fromTo(idOf("23-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg23Anim.stop();
          resetNumbers("23-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "COUPE DU MONDE DE FLEURET MASCULIN PARIS, FRANCE 2/2  Le champion olympique hongkongais Ka Long Cheung a remporté le titre individuel du Challenge International de Paris de la Coupe du monde de fleuret masculin. L'équipe d'Italie est repartie avec l'or de l'épreuve par équipes. La compétition, qui s'est déroulée au stade Pierre de Coubertin, a attiré 210 fleurettistes et 26 équipes. En finale du fleuret individuel, Cheung a battu l'Italien Edoardo Luperi sur le score de 15 touches à 12. En demi-finale, Luperi avait éliminé l'Américain Chase Emmer (15-13) et Cheung avait terrassé le champion du monde italien Alessio Foconi (15-4). En quart de finale, Cheung avait également mis fin au parcours du champion du monde français Enzo Lefort (159), et Emmer avait sorti le champion olympique italien Daniele Garozzo (15-5). L'Italie a remporté l'or de l'épreuve de fleuret par équipes en s'imposant en finale face à la France (45-20). En demi-finale, la France avait éliminé la Russie (45-39) et l'Italie avait fait chuter les États-Unis (45-38). Les Américains ont remporté la médaille de bronze en battant les Russes 45 touches à 31.  Les huit premiers au classement final du fleuret individuel sont Ka Long Cheung (HKG, or), Edoardo Luperi (ITA, argent), Chase Emmer (USA, bronze), Alessio Foconi (ITA, bronze), Daniele Garozzo (ITA), Chun Yin Ryan Choi (HKG), Enzo Lefort (FRA) et Alexandre Sido (FRA). Au classement final de l'épreuve de fleuret par équipes, l'Italie arrive en tête (or), suivie de la France (argent), des États-Unis (bronze), de la Russie, du Japon, de l'Égypte, de la Corée et de Hong Kong. Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la chaîne YouTube de la FIE. ■ W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 23,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg24.jpg",
      "zoom": null,
      "content": `
        <a href="https://www.blaise-freres.fr" target="_blank">
          <div class="contentLinkNone" style="  bottom: 173px; right: 981px; width: 177px; height: 25px; }"></div>
        </a>
      `,
      "mobileHtml": `
        <a href="https://www.blaise-freres.fr" target="_blank">
          <img src="/120/fr/static/_content/pg24.jpg">
        </a>
      `,  
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 24,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg25.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 25-title" style="top:86px;left:485px;" src="/120/fr/static/_content/25-sub-2.png">
        <img class="abs halfScale 25-sub" style="top:276px;left:770px;" src="/120/fr/static/_content/25-sub-1.png">
        <img class="abs halfScale 25-line" style="top:273px;left:738px;" src="/120/fr/static/_content/25-line-1.png">
        <img id="25-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2 id="italy-s-volpi-team-usa-win-gold-at-poznan-women-s-foil-world-cup">
          Coupe du monde de fleuret féminin : l'or pour l'Italienne Volpi et les Américaines à Poznan</h2>
        <p><strong>Poznan, Pologne<br>14-16 Janvier 2022</strong></p>
        <img src="/120/fr/static/_content/25-mobile-1.jpg">
        <p><strong>La championne du monde italienne Alice Volpi a remporté l'or de l'épreuve individuelle de la Coupe du monde de fleuret féminin à Poznan, et les États-Unis le titre de l'épreuve par équipes. </strong></p>
        <p>La compétition, organisée à l'UAM Sport Center, a été disputée par 180 fleurettistes et 20 équipes.</p>
        <p>Volpi a remporté la finale de l'épreuve individuelle face à la Canadienne Eleanor Harvey sur le score de 15 touches à 10. En demi-finale, Harvey avait battu la Chinoise Qingyuan Chen (15-7) et Volpi avait éliminé sa coéquipière Martina Favaretto (15-11).</p>
        <p>Les Américaines ont décroché l'or par équipes en s'adjugeant la victoire en finale face au Japon sur le score de 45-23. En demi-finale, le Japon avait éliminé la Pologne (27-25) et les États-Unis s'étaient imposés face à la Russie (45-39). La Pologne a décroché la médaille de bronze en battant la Russie en petite finale 44 touches à 42.</p>
        <p>Les huit premières au classement du fleuret individuel sont Alice Volpi (ITA, or), Eleanor Harvey (CAN, argent), Martina Favaretto (ITA, bronze), Qingyuan Chen (CHN, bronze), Francesca Palumbo (ITA), Kata Kondricz (HUN), Alexandra Sunduchkova (RUS) et Elena Petrova (RUS).</p>
        <p>Au classement du fleuret par équipes, les États-Unis arrivent en tête (or), suivis du Japon (argent), de la Pologne (bronze), de la Russie, de l'Italie, de la Chine, de la France et du Canada.</p>
        <p>Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la chaîne YouTube de la FIE.</p>
      `,
      "script": `
        function onPageEnter() {
          pg25Anim = new TimelineMax();
          pg25Anim
            .fromTo(cOf("25-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("25-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("25-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("25-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
        
        function onPageLeave() {
          pg25Anim.stop();
          resetNumbers("25-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  COUPE DU MONDE DE FLEURET FÉMININ : L'OR POUR L'ITALIENNE VOLPI ET LES AMÉRICAINES À POZNAN POZNAN, POLOGNE 14-16 JANVIER 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 25,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg26.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-red.png">
        </a>

        <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="bottom: 178px; right: 178px; width: 213px; height: 20px;"></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink" style="bottom: 131px; right: 150px; width: 129px; height: 20px;"></div>
          <div class="addContentLink" style="bottom: 109px; right: 450px; width: 75px; height: 20px;"></div>
        </a>

        <img id="26-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg26Anim = new TimelineMax();
          pg26Anim
            .fromTo(idOf("26-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg26Anim.stop();
          resetNumbers("26-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "COUPE DU MONDE DE FLEURET FÉMININ POZNAN, POLOGNE 2/2  La championne du monde italienne Alice Volpi a remporté l'or de l'épreuve individuelle de la Coupe du monde de fleuret féminin à Poznan, et les ÉtatsUnis le titre de l'épreuve par équipes. La compétition, organisée à l'UAM Sport Center, a été disputée par 180 fleurettistes et 20 équipes. Volpi a remporté la finale de l'épreuve individuelle face à la Canadienne Eleanor Harvey sur le score de 15 touches à 10. En demi-finale, Harvey avait battu la Chinoise Qingyuan Chen (15-7) et Volpi avait éliminé sa coéquipière Martina Favaretto (15-11).  Les Américaines ont décroché l'or par équipes en s'adjugeant la victoire en finale face au Japon sur le score de 45-23. En demi-finale, le Japon avait éliminé la Pologne (27-25) et les États-Unis s'étaient imposés face à la Russie (45-39). La Pologne a décroché la médaille de bronze en battant la Russie en petite finale 44 touches à 42. Les huit premières au classement du fleuret individuel sont Alice Volpi (ITA, or), Eleanor Harvey (CAN, argent), Martina Favaretto (ITA, bronze), Qingyuan Chen (CHN, bronze), Francesca Palumbo (ITA), Kata Kondricz (HUN), Alexandra Sunduchkova (RUS) et Elena Petrova (RUS). Au classement du fleuret par équipes, les États-Unis arrivent en tête (or), suivis du Japon (argent), de la Pologne (bronze), de la Russie, de l'Italie, de la Chine, de la France et du Canada. Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la chaîne YouTube de la FIE. ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 26,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg27.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 27-title" style="top:64px;left:423px;" src="/120/fr/static/_content/27-title-1.png">
        <img class="abs halfScale 27-sub" style="top:301px;left:454px;" src="/120/fr/static/_content/27-sub-1.png">
        <img class="abs halfScale 27-line" style="top:304px;left:422px;" src="/120/fr/static/_content/27-line-1.png">
        <img id="27-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
      <h2
        id="georgia-s-bazadze-france-s-queroli-teams-korea-and-france-win-gold-at-tbilisi-sabre-world-cup">Coupe de monde de sabre : l'or à Tbilissi pour le Géorgien Bazadze, la Française Queroli, l'équipe de Corée et l'équipe de France</h2>
        <p><strong>Tbilissi, Géorgie<br>14-18 Janvier 2022</strong></p>
        <img src="/120/fr/static/_content/27-mobile-1.jpg">
        <p><strong>Le Géorgien Sandro Bazadze et la Française Caroline Queroli ont remporté l'or des épreuves individuelles de la Coupe du monde de sabre de Tbilissi. </strong></p>
        <p>La Corée et la France s'octroient l'or des épreuves par équipes masculine et féminine. La compétition, organisée à l'Olympic Palace, a été disputée par 188 tireurs et 154 tireuses en individuel, et 24 équipes masculines et 25 équipes féminines.</p>
        <p>Bazadze a battu le Russe Kamil Ibragimov en finale du sabre individuel masculin sur le score de 15-8. En demi-finale, Ibragimov avait éliminé le champion du monde coréen Junghwan Kim (15-12) et Bazadze avait sorti le Français Bolade Apithy (15-10). En quart de finale, Apithy avait évincé le champion du monde coréen Sanguk Oh (15-8) et Kim avait battu le champion du monde hongrois Andras Szatmari (15-12).</p>
        <p>La finale du sabre féminin individuel a été remportée par Queroli face à la Grecque Theodora Gkountoura sur le score de 15-12. En demi-finale, Gkountoura a dû puiser dans ses ressources pour battre la championne olympique russe Yana Egorian (15-14), tout comme Queroli victorieuse sur le fil de l'Italienne Rossella Gregorio (15-14).</p>
        <p>Au sabre masculin par équipes, la Corée a remporté la finale face à l'Allemagne (45-38). En demi-finale, les Allemands avaient éliminé les Italiens (45-43) et les Coréens avaient battu les Russes (45-44). La Russie est repartie avec la médaille de bronze au détriment de l'Italie (45-40).</p>
        <p>Au sabre féminin par équipes, la France est montée sur la plus haute marche du podium après avoir vaincu la Corée en finale (45-35). En demi-finale, la France avait battu l'Espagne (45-34) et la Corée avait éliminé la Russie (45-39). La médaille de bronze est revenue aux Russes après une victoire serrée en petite finale face aux Espagnoles (45-43).</p>
        <p>Les huit premières au classement final du sabre individuel féminin sont Caroline Quéroli (FRA, or), Theodóra Gkountoúra (GRE, argent), Yana Egorian (RUS, bronze), Rossella Gregorio (ITA, bronze), Manon Apithy-Brunet (FRA), Svetlana Sheveleva (RUS), Sara Balzer (FRA) et Seri Ozaki (JPN).</p>
        <p>Les huit premières équipes au classement final du sabre masculin par équipes sont la Corée (or), l'Allemagne (argent), la Russie (bronze), l'Italie, l'Iran, l'Égypte, la Hongrie et la France.</p>
        <p>Les huit premières équipes au classement final du sabre féminin par équipes sont la France (or), la Corée (argent), la Russie (bronze), l'Espagne, l'Italie, la Bulgarie, la Hongrie et la Pologne..</p>
        <p>Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la chaîne YouTube de la FIE.</p>
      `,
      "script": `
        function onPageEnter() {
          pg27Anim = new TimelineMax();
          pg27Anim
            .fromTo(cOf("27-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("27-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("27-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("27-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        
        function onPageLeave() {
          pg27Anim.stop();
          resetNumbers("27-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  COUPE DE MONDE DE SABRE : L'OR À TBILISSI POUR LE GÉORGIEN BAZADZE, LA FRANÇAISE QUEROLI, L'ÉQUIPE DE CORÉE ET L'ÉQUIPE DE FRANCE TBILISSI, GÉORGIE 14-18 JANVIER 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 27,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg28.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-red.png">
        </a>

        <img id="28-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg28Anim = new TimelineMax();
          pg28Anim
            .fromTo(idOf("28-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg28Anim.stop();
          resetNumbers("28-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "COUPE DE MONDE DE SABRE TBILISI, GÉORGIE 2/3  Le Géorgien Sandro Bazadze et la Française Caroline Queroli ont remporté l'or des épreuves individuelles de la Coupe du monde de sabre de Tbilissi. La Corée et la France s'octroient l'or des épreuves par équipes masculine et féminine. La compétition, organisée à l'Olympic Palace, a été disputée par 188 tireurs et 154 tireuses en individuel, et 24 équipes masculines et 25 équipes féminines. Bazadze a battu le Russe Kamil Ibragimov en finale du sabre individuel masculin sur le score de 15-8. En demi-finale, Ibragimov avait éliminé le champion du monde coréen Junghwan Kim (15-12) et Bazadze avait sorti le Français Bolade Apithy (15-10). En quart de finale, Apithy avait évincé le champion du monde coréen Sanguk Oh (15-8) et Kim avait battu le champion du monde hongrois Andras Szatmari (15-12). La finale du sabre féminin individuel a été remportée par Queroli face à la Grecque Theodora Gkountoura sur le score de 15-12. En demi-finale, Gkountoura a dû puiser dans ses ressources pour battre la championne olympique russe Yana Egorian (15-14), tout  comme Queroli victorieuse sur le fil de l'Italienne Rossella Gregorio (15-14). Au sabre masculin par équipes, la Corée a remporté la finale face à l'Allemagne (45-38). En demi-finale, les Allemands avaient éliminé les Italiens (45-43) et les Coréens avaient battu les Russes (45-44). La Russie est repartie avec la médaille de bronze au détriment de l'Italie (45-40)."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 28,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg29.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-red.png">
        </a>

        <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="bottom: 296px; right: 435px; width: 91px; height: 20px;"></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink"
            style="bottom: 272px; right: 150px; width: 127px; height: 20px;"></div>
          <div class="addContentLink"
            style="bottom: 249px; right: 451px; width: 74px; height: 20px;"></div>
        </a>

        <img id="29-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg29Anim = new TimelineMax();
          pg29Anim
            .fromTo(idOf("29-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg29Anim.stop();
          resetNumbers("29-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "COUPE DE MONDE DE SABRE TBILISI, GÉORGIE 3/3  Au sabre féminin par équipes, la France est montée sur la plus haute marche du podium après avoir vaincu la Corée en finale (45-35). En demi-finale, la France avait battu l'Espagne (45-34) et la Corée avait éliminé la Russie (4539). La médaille de bronze est revenue aux Russes après une victoire serrée en petite finale face aux Espagnoles (45-43). Les huit premières au classement final du sabre individuel féminin sont Caroline Quéroli (FRA, or), Theodóra Gkountoúra (GRE, argent), Yana Egorian (RUS, bronze), Rossella Gregorio (ITA, bronze), Manon Apithy-Brunet (FRA), Svetlana Sheveleva (RUS), Sara Balzer (FRA) et Seri Ozaki (JPN). Les huit premières équipes au classement final du sabre masculin par équipes sont la Corée (or), l'Allemagne (argent), la Russie (bronze), l'Italie, l'Iran, l'Égypte, la Hongrie et la France.  Les huit premières équipes au classement final du sabre féminin par équipes sont la France (or), la Corée (argent), la Russie (bronze), l'Espagne, l'Italie, la Bulgarie, la Hongrie et la Pologne. Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la chaîne YouTube de la FIE. ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 29,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg30.jpg",
      "zoom": null,
      "content": `
        <a href="https://www.facebook.com/uhlmann.fencing/" target="_blank">
          <div class="contentLinkNone" style="bottom: 39px; right: 1095px; width: 19px; height: 18px;"></div>
        </a>
        <a href="https://www.instagram.com/uhlmann.fencing/" target="_blank">
          <div class="contentLinkNone" style="bottom: 39px; right: 1074px; width: 19px; height: 18px;"></div>
        </a>
        <a href="https://uhlmann-fechtsport.com/en/" target="_blank">
          <div class="contentLinkNone" style="bottom: 39px; right: 966px; width: 104px; height: 18px;"></div>
        </a>
      `,
      "mobileHtml": `
        <a href="https://uhlmann-fechtsport.com/en/" target="_blank">
          <img src="/120/fr/static/_content/30-mobile-1.jpg">
        </a>
      `,      
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 30,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg31.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 31-title" style="top:73px;left:65px;" src="/120/fr/static/_content/31-title-1.png">
        <img class="abs halfScale 31-sub" style="top:232px;left:97px;" src="/120/fr/static/_content/31-sub-1.png">
        <img class="abs halfScale 31-line" style="top:231px;left:64px;" src="/120/fr/static/_content/31-line-1.png">
        <img id="31-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2 id="azerbaijans-bashta-team-france-win-gold-at-women-s-sabre-world-cup">Coupe du Monde de Sabre Féminin : l'Azerbaïdjanaise Anna Bashta et l'équipe de France remportent l'or à Plovdiv</h2>
        <img src="/120/fr/static/_content/31-mobile-1.jpg">
        <p><strong>Plovdiv, Bulgarie<br>28-30 Janvier 2022</strong></p>
        <p><strong>L'Azerbaïdjanaise Anna Bashta et l'équipe de France ont décroché les médailles d'or de la Coupe du monde de sabre féminin à Plovdiv, Bulgarie.  </strong></p>
        <p>La compétition, organisée au Complex SILA, a été disputée par 136 sabreuses et 20 équipes.</p>
        <p>Bashta a remporté la finale de l'épreuve individuelle face à la Française Manon Apithy-Brunet (15-10). En demi-finale, Apithy-Brunet avait éliminé sa coéquipière Malina Vongsavady (15-9) et Bashta avait fait chuter l'Italienne Rossella Gregorio (15-13).</p>
        <p>Dans l'épreuve par équipes, la France a battu l'Azerbaïdjan en finale sur le score de 45 touches à 39. En demi-finale, les Azerbaïdjanaises avaient écarté les Bulgares (45-32), et les Françaises avaient éliminé les Italiennes (45-23). L'Italie a par la suite remporté la médaille de bronze au détriment de la Bulgarie (45-29).</p>
        <p>Les huit premières au classement final de l'épreuve de sabre individuel sont Anna Bashta (AZE, or), Manon Apithy-Brunet (FRA, argent), Rossella Gregorio (ITA, bronze), Malina Vongsavady (FRA, bronze), Liza Pusztai (HUN), Misaki Emura (JPN), Olga Nikitina (RUS) et Svetlana Sheveleva (RUS).</p>
        <p>Au classement de la compétition de sabre par équipes, la France arrive première (or), suivie de l'Azerbaïdjan (argent), l'Italie (bronze), la Bulgarie, la Hongrie, l'Espagne, la Turquie et l'Allemagne.</p>
        <p>Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la chaîne YouTube de la FIE.</p>
      `,
      "script": `
        function onPageEnter() {
          pg31Anim = new TimelineMax();
          pg31Anim
            .fromTo(cOf("31-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("31-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("31-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("31-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        
        function onPageLeave() {
          pg31Anim.stop();
          resetNumbers("31-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  COUPE DU MONDE DE SABRE FÉMININ : L'AZERBAÏDJANAISE ANNA BASHTA ET L'ÉQUIPE DE FRANCE REMPORTENT L'OR À PLOVDIV PLOVDIV, BULGARIA 28-30 JANUARY 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 31,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg32.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-red.png">
        </a>

        <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="bottom: 107px; right: 435px; width: 92px; height: 20px;"></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink"
            style="bottom: 83px; right: 150px; width: 129px; height: 20px;"></div>
          <div class="addContentLink"
            style="bottom: 61px; right: 450px; width: 76px; height: 20px;"></div>
        </a>

        <img id="32-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg32Anim = new TimelineMax();
          pg32Anim
            .fromTo(idOf("32-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg32Anim.stop();
          resetNumbers("32-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "COUPE DU MONDE DE SABRE FÉMININ PLOVDIV, BULGARIE, 2/2  L'Azerbaïdjanaise Anna Bashta et l'équipe de France ont décroché les médailles d'or de la Coupe du monde de sabre féminin à Plovdiv, Bulgarie. La compétition, organisée au Complex SILA, a été disputée par 136 sabreuses et 20 équipes. Bashta a remporté la finale de l'épreuve individuelle face à la Française Manon ApithyBrunet (15-10). En demi-finale, Apithy-Brunet avait éliminé sa coéquipière Malina Vongsavady (15-9) et Bashta avait fait chuter l'Italienne Rossella Gregorio (15-13). Dans l'épreuve par équipes, la France a battu l'Azerbaïdjan en finale sur le score de 45 touches à 39. En demi-finale, les Azerbaïdjanaises avaient écarté les Bulgares (45-32), et les Françaises avaient éliminé les Italiennes (45-23). L'Italie a  par la suite remporté la médaille de bronze au détriment de la Bulgarie (45-29). Les huit premières au classement final de l'épreuve de sabre individuel sont Anna Bashta (AZE, or), Manon Apithy-Brunet (FRA, argent), Rossella Gregorio (ITA, bronze), Malina Vongsavady (FRA, bronze), Liza Pusztai (HUN), Misaki Emura (JPN), Olga Nikitina (RUS) et Svetlana Sheveleva (RUS). Au classement de la compétition de sabre par équipes, la France arrive première (or), suivie de l'Azerbaïdjan (argent), l'Italie (bronze), la Bulgarie, la Hongrie, l'Espagne, la Turquie et l'Allemagne. Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la chaîne YouTube de la FIE. ■ W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 32,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg33.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 33-title" style="top:65px;left:395px;" src="/120/fr/static/_content/33-title-1.png">
        <img class="abs halfScale 33-sub" style="top:274px;left:426px;" src="/120/fr/static/_content/33-sub-1.png">
        <img class="abs halfScale 33-line" style="top:271px;left:394px;" src="/120/fr/static/_content/33-line-1.png">
        <img id="33-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2 id="france-s-borel-estonia-s-lehis-win-qatar-epee-grand-prix">Grand Prix d'épée : le Français Borel et l'Estonienne Lehis s'emparent de l'or au Qatar</h2>
        <img src="/120/fr/static/_content/33-mobile-1.jpg">
        <p><strong>Doha, Qatar<br>28-30 Janvier 2022</strong></p>
        <p><strong>Le champion du monde français Yannick Borel et l'Estonienne Katrina Lehis ont remporté les médailles d'or de l'étape qatarienne du Grand Prix d'épée 2022 à Doha. </strong></p>
        <p>La compétition, organisée au complexe sportif Aspire Zone/Aspire Dome, a été disputée par 161 tireurs et 120 tireuses.</p>
        <p>Borel a battu son coéquipier Aymerick Gally en finale de l'épée masculine individuelle sur le score de 15-10. En demi-finale, Gally avait éliminé l'Italien Federico Vismara (15-6), et Borel avait fait chuter l'Italien Davide Di Veroli (15-9) après avoir sorti en quart de finale le champion olympique français Romain Cannone (15-5). À noter également la défaite du champion du monde Gergely Siklosi face à Di Veroli dans le tableau de 16 (15-12).</p>
        <p>La finale de l'épée féminine individuelle a été remportée par Lehis face à sa coéquipière Nelli Differt (15-11). En demi-finale, Differt avait battu une autre de ses coéquipières, Erika Kirpu (12-11), et Lehis avait éliminé sur le fil la Française Marie-Florence Candassamy (15-14), après avoir vaincu en quart de finale la championne olympique ukrainienne Yana Shemyakina (15-9).</p>
        <p>Les huit premiers au classement final de l'épée masculine sont Yannick Borel (FRA, or), Aymerick Gally (FRA, argent), Davide Di Veroli (ITA, bronze), Federico Vismara (ITA, bronze), Igor Reizlin (UKR), Romain Cannone (FRA), Alexandre Bardenet (FRA) et Volodymyr Stankevych (UKR).</p>
        <p>Les huit premières au classement final de l'épée féminine sont Katrina Lehis (EST, or), Nelli Differt (EST, argent), Marie-Florence Candassamy (FRA, bronze), Erika Kirpu (EST, bronze), Renata Knapik-Miazga (POL), Irina Embrich (EST), Anna Kun (HUN) et Yana Shemyakina (UKR).</p>
        <p>Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la chaîneYouTube de la FIE.</p>
      `,
      "script": `
        function onPageEnter() {
          pg33Anim = new TimelineMax();
          pg33Anim
            .fromTo(cOf("33-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("33-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("33-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("33-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        
        function onPageLeave() {
          pg33Anim.stop();
          resetNumbers("33-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  GRAND PRIX D'ÉPÉE : LE FRANÇAIS BOREL ET L'ESTONIENNE LEHIS S'EMPARENT DE L'OR AU QATAR DOHA, QATAR 28-30 JANVIER 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 33,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg34.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-red.png">
        </a>

        <img id="34-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg34Anim = new TimelineMax();
          pg34Anim
            .fromTo(idOf("34-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg34Anim.stop();
          resetNumbers("34-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "GRAND PRIX D'ÉPÉE DOHA, QATAR 2/2  Le champion du monde français Yannick Borel et l'Estonienne Katrina Lehis ont remporté les médailles d'or de l'étape qatarienne du Grand Prix d'épée 2022 à Doha. La compétition, organisée au complexe sportif Aspire Zone/Aspire Dome, a été disputée par 161 tireurs et 120 tireuses. Borel a battu son coéquipier Aymerick Gally en finale de l'épée masculine individuelle sur le score de 15-10. En demi-finale, Gally avait éliminé l'Italien Federico Vismara (156), et Borel avait fait chuter l'Italien Davide Di Veroli (15-9) après avoir sorti en quart de finale le champion olympique français Romain Cannone (15-5). À noter également la défaite du champion du monde Gergely Siklosi face à Di Veroli dans le tableau de 16 (15-12). La finale de l'épée féminine individuelle a été remportée par Lehis face à sa coéquipière Nelli Differt (15-11). En demi-finale, Differt avait battu une autre de ses coéquipières, Erika Kirpu (1211), et Lehis avait éliminé sur le fil la Française Marie-Florence Candassamy (15-14), après avoir vaincu en quart de finale la championne olympique ukrainienne Yana Shemyakina (15-9).  Les huit premiers au classement final de l'épée masculine sont Yannick Borel (FRA, or), Aymerick Gally (FRA, argent), Davide Di Veroli (ITA, bronze), Federico Vismara (ITA, bronze), Igor Reizlin (UKR), Romain Cannone (FRA), Alexandre Bardenet (FRA) et Volodymyr Stankevych (UKR). Les huit premières au classement final de l'épée féminine sont Katrina Lehis (EST, or), Nelli Differt (EST, argent), Marie-Florence Candassamy (FRA, bronze), Erika Kirpu (EST, bronze), Renata Knapik-Miazga (POL), Irina Embrich (EST), Anna Kun (HUN) et Yana Shemyakina (UKR). Retrouvez tous les résultats officiels de la compétition sur le site Internet de la FIE en cliquant ici. Pour suivre l'actualité palpitante de l'escrime mondiale, regardez la chaîne YouTube de la FIE. ■ W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 34,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg35.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 35-title" style="top:88px;left:381px;" src="/120/fr/static/_content/35-title-1.png">
        <img class="abs halfScale 35-sub" style="top:235px;left:410px;" src="/120/fr/static/_content/35-sub-1.png">
        <img class="abs halfScale 35-line" style="top:232px;left:378px;" src="/120/fr/static/_content/35-line-1.png">
        <img id="35-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2 id="men-s-and-women-s-epee-grand-prix-in-budapest">Coupe du monde de sabre masculin : un doublé en or pour la Hongrie à Budapest</h2>
        <img src="/120/fr/static/_content/35-mobile-1.jpg">
        <p><strong>Budapest, Hongrie<br>4-6 Mars 2022</strong></p>
        <p><strong>Le triple champion olympique hongrois Aron Szilagyi a décroché l'or de l'épreuve individuelle de la Coupe du monde de sabre de Budapest, avant de remonter sur la plus haute marche du podium à l'issue de l'épreuve par équipes aux côtés de ses coéquipiers.</strong></p>
        <p>La Coupe du monde de sabre individuel « Gerevich-Kovács-Kárpáti » et la Coupe du monde de sabre par équipes « Zarándi Csaba » disputées à Budapest ont réuni 204 tireurs et 23 équipes au BOK Hall (anciennement SYMA Hall) de la capitale hongroise. </p>
        <p>Szilagyi a décroché le sésame de l'épreuve individuelle en s'imposant en finale face à l'Italien Luca Curatoli (15-7). En demi-finale, Curatoli avait éliminé le champion du monde coréen Sanguk Oh (15-8), et Szilagyi avait battu sur le fil un autre champion du monde coréen, Junghwan Kim (15-14).</p>
        <p>La finale de l'épreuve par équipes a été remportée par la Hongrie face à la France (45-38). En demi-finale, la France avait éliminé l'Allemagne (45-40), la Hongrie s'imposant quant à elle face à la Roumanie (45-30). L'Allemagne est repartie avec la médaille de bronze au détriment de la Roumanie (45-43). 
        </p>
        <p>Les huit premiers au classement final du sabre masculin individuel sont Aron Szilagyi (HUN, or), Luca Curatoli (ITA, argent), Junghwan Kim (KOR, bronze), Sanguk Oh (KOR, bronze), Boladé Apithy (FRA), Luigi Samele (ITA), Daryl Homer (USA) et Matyas Szabo (GER). </p>
        <p>Les huit premières nations au classement final du sabre masculin par équipes sont la Hongrie (or), la France (argent), l'Allemagne (bronze), la Roumanie, la Corée, les USA, l'Italie et l'Iran.</p>
      `,
      "script": `
        function onPageEnter() {
          pg35Anim = new TimelineMax();
          pg35Anim
            .fromTo(cOf("35-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("35-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("35-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("35-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        
        function onPageLeave() {
          pg35Anim.stop();
          resetNumbers("35-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  COUPE DU MONDE DE SABRE MASCULIN : UN DOUBLÉ EN OR POUR LA HONGRIE À BUDAPEST BUDAPEST, HONGRIE 4–6 MARS 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 35,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg36.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-red.png">
        </a>

        <img id="36-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg36Anim = new TimelineMax();
          pg36Anim
            .fromTo(idOf("36-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg36Anim.stop();
          resetNumbers("36-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "COUPE DU MONDE DE SABRE MASCULIN BUDAPEST, HONGRIE 2/3  Le triple champion olympique hongrois Aron Szilagyi a décroché l'or de l'épreuve individuelle de la Coupe du monde de sabre de Budapest, avant de remonter sur la plus haute marche du podium à l'issue de l'épreuve par équipes aux côtés de ses coéquipiers. La Coupe du monde de sabre individuel « Gerevich-Kovács-Kárpáti » et la Coupe du monde de sabre par équipes « Zarándi Csaba » disputées à Budapest ont réuni 204 tireurs et 23 équipes au BOK Hall (anciennement SYMA Hall) de la capitale hongroise.  Szilagyi a décroché le sésame de l'épreuve individuelle en s'imposant en finale face à l'Italien Luca Curatoli (15-7). En demi-finale, Curatoli avait éliminé le champion du monde coréen Sanguk Oh (15-8), et Szilagyi avait battu sur le fil un autre champion du monde coréen, Junghwan Kim (15-14). La finale de l'épreuve par équipes a été remportée par la Hongrie face à la France (4538). En demi-finale, la France avait éliminé l'Allemagne (45-40), la Hongrie s'imposant quant à elle face à la Roumanie (45-30). L'Allemagne est repartie avec la médaille de bronze au détriment de la Roumanie (45-43)."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 36,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg37.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-red.png">
        </a>

        <!-- <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="  bottom: 624px; right: 156px; width: 114px; height: 20px; "></div>
        </a> -->
        
        <!-- <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink"
            style="bottom: 577px; right: 152px; width: 111px; height: 20px;"></div>
          <div class="addContentLink"
            style="bottom: 554px; right: 388px; width: 139px; height: 20px;"></div>
        </a> -->

        <img id="37-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg37Anim = new TimelineMax();
          pg37Anim
            .fromTo(idOf("37-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg37Anim.stop();
          resetNumbers("37-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "COUPE DU MONDE DE SABRE MASCULIN BUDAPEST, HONGRIE 3/3  Les huit premiers au classement final du sabre masculin individuel sont Aron Szilagyi (HUN, or), Luca Curatoli (ITA, argent), Junghwan Kim (KOR, bronze), Sanguk Oh (KOR, bronze), Boladé Apithy (FRA), Luigi Samele (ITA), Daryl Homer (USA) et Matyas Szabo (GER).  Les huit premières nations au classement final du sabre masculin par équipes sont la Hongrie (or), la France (argent), l'Allemagne (bronze), la Roumanie, la Corée, les USA, l'Italie et l'Iran. ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 37,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg38.jpg",
      "zoom": null,
      "content": ``,
      "mobileHtml": `
        <img src="/120/fr/static/_content/38-mobile-1.jpg">
      `,      
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 38,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg39.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 39-title" style="top:75px;left:64px;" src="/120/fr/static/_content/39-title-1.png">
        <img class="abs halfScale 39-sub" style="top:220px;left:97px;" src="/120/fr/static/_content/39-sub-1.png">
        <img class="abs halfScale 39-line" style="top:223px;left:64px;" src="/120/fr/static/_content/39-line-1.png">
        <img id="39-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2
          id="a-grand-and-successful-2022-junior-and-cadet-fencing-world-championships-in-dubai">Les Championnats du monde d'escrime juniors et cadets 2022 aussi grandioses que réussis à Dubaï </h2>
        <img src="/120/fr/static/_content/39-mobile-1.jpg">
        <p><strong>Dubaï, Émirats arabes unis<br>2 au 10 avril 2022</strong></p>
        <p><strong>Les Championnats du monde d'escrime juniors et cadets 2022 ont été qualifiés de « succès spectaculaire » par le président intérimaire de la FIE, Emmanuel Katsiadakis. </strong></p>
        <p>La compétition, qui se déroulait sur neuf jours et comptait 18 épreuves individuelles et par équipes pour les tireurs et tireuses juniors et cadets, a enregistré le plus grand nombre de participants de son histoire, avec 1 357 escrimeurs en lice venus de 103 pays. Les championnats ont été organisés dans l'impressionnant Complexe sportif Hamdan de Dubaï, un complexe multisports de calibre mondial connu pour avoir accueilli un grand nombre de championnats et événements internationaux. </p>
        <p>Le tableau suivant récapitule le nombre de pays ayant participé aux Championnats du monde d'escrime juniors et cadets, par régions continentales :</p>
        <ul>
          <li>
            Afrique 13</li>
          <li>
            Amériques 20</li>
          <li>
            Asie/Océanie 32</li>
          <li>
            Europe 38</li>
          <li>
            Total 103 </li>
          </ul>
          <p>La cérémonie d'ouverture officielle des championnats s'était déroulée en présence de plusieurs dignitaires locaux : Son Excellence Dr. Ahmad bin Abdullah Humaid Belhoul Al Falasi, Ministre d'État en charge de l'Entreprenariat et des PME, et Président du Conseil d'administration de l'Autorité sportive générale ; Son Excellence Sheikh Salem bin Sultan Al Qasimi, membre du Comité exécutif de la FIE, président de la Confédération asiatique d'escrime, président de la Fédération arabe d'escrime et président de la Fédération d'escrime des EAU ; Son Excellence Saeed Hareb, secrétaire général du Comité sportif de Dubaï ; et Son Excellence Nasser Al Rahma, vice-président du complexe sportif de Hamdan. Les championnats ont été déclarés officiellement ouverts par le Président intérimaire de la FIE, Emmanuel Katsiadakis. </p>
          <p>Trois jours de compétition consécutifs ont été consacrés à chaque arme (sabre, fleuret, épée). Chaque cycle de trois jours incluait les épreuves masculines et féminines individuelles juniors le premier jour, les épreuves individuelles cadets le deuxième jour et les épreuves par équipes juniors le dernier jour. </p>
          <p>Les protocoles COVID-19 ont été respectés pendant les Championnats afin de garantir la sécurité de tous les participants et des personnes présentes, avec notamment le port du masque, le respect des mesures de distanciation sociale et des tests réguliers. 
            Les huit premiers au classement général des différentes épreuves sont les suivants :</p>
          <p>Sabre</p>
          <ul>
            <li>
              Sabre masculin individuel junior (152 tireurs)<ol>
                <li>
                  Colin Heathcock (GER, or)</li>
                <li>
                  Pietro Torre (ITA, argent)</li>
                <li>
                  Antonio Heathcock (GER, bronze)</li>
                <li>
                  Heegeun Hwang (KOR, bronze)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Sabre féminin individuel junior (126 tireuses)<ol>
                <li>
                  Magda Skarbonkiewicz (USA, or)</li>
                <li>
                  Honor Johnson (USA, argent)</li>
                <li>
                  Zaynab Dayibekova (UZB, bronze)</li>
                <li>
                  Sugar Katinka Battai (HUN, bronze)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Sabre masculin individuel cadet (95 tireurs)<ol>
                <li>
                  Zuhridden Kodirov (UZB, or)</li>
                <li>
                  Colin Heathcock (GER, argent)</li>
                <li>
                  Cody Ji (USA, bronze)</li>
                <li>
                  William Morrill (USA, bronze)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Sabre féminin individuel cadet (90 tireuses)<ol>
                <li>
                  Magda Skarbonkiewicz (USA, or)</li>
                <li>
                  Siobhan Sullivan (USA, argent)</li>
                <li>
                  Alejandra Manga (FRA, bronze)</li>
                <li>
                  Eunyu Kim (KOR, bronze)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Sabre masculin par équipes junior (34 équipes)<ol>
                <li>
                  Italie (or)</li>
                <li>
                  Roumanie (argent)</li>
                <li>
                  Égypte (bronze)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Sabre féminin par équipes junior (27 équipes)<ol>
                <li>
                  France (or)</li>
                <li>
                  Hongrie (argent)</li>
                <li>
                  Italie (bronze)</li>
              </ol>
            </li>
          </ul>
          <p>FLEURET</p>
          <ul>
            <li>
              Fleuret masculin individuel junior (180 tireurs)<ol>
                <li>
                  Kazuki Iimura (JPN, or)</li>
                <li>
                  Hyeonbhin An (KOR, argent)</li>
                <li>
                  Anas Anane (FRA, bronze)</li>
                <li>
                  Chase T. Emmer (USA, bronze)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Fleuret féminin individuel junior (148 tireuses)<ol>
                <li>
                  Lauren Scruggs (USA, or)</li>
                <li>
                  Yuzuha Takeyama (JPN, argent)</li>
                <li>
                  Carolina Stutchbury (GBR, bronze)</li>
                <li>
                  Kateryna Budenko (UKR, bronze)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Fleuret masculin individuel cadet (117 tireurs)<ol>
                <li>
                  Tit Nam Cheng (HKG, or)</li>
                <li>
                  Ruben Lindner (GER, argent)</li>
                <li>
                  Matteo Iacomoni (ITA, bronze)</li>
                <li>
                  Andrew Chen (USA, bronze)</li>
              </ol>
            </li>
            <li>
              Fleuret féminin individuel cadet (104 tireuses)<ol>
                <li>
                  Jessica Zi Jia Guo (CAN, or)</li>
                <li>
                  Carolina Stutchbury (GBR, argent)</li>
                <li>
                  Rino Nagase (JPN, bronze)</li>
                <li>
                  Matilde Molinari (ITA, bronze)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Fleuret masculin par équipes junior (37 équipes)<ol>
                <li>
                  Italie (or)</li>
                <li>
                  France (argent)</li>
                <li>
                  Hongrie (bronze)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Fleuret féminin par équipes junior (32 équipes)<ol>
                <li>
                  USA (or)</li>
                <li>
                  Italie (argent)</li>
                <li>
                  Japon (bronze)</li>
              </ol>
            </li>
          </ul>
          <p>Épée </p>
          <ul>
            <li>
              Épée masculine individuelle junior (208 tireurs)<ol>
                <li>
                  Zsombor Keszthelyi (HUN, or)</li>
                <li>
                  Mohamed Yasseen (EGY, argent)</li>
                <li>
                  James Jeal (GBR, bronze)</li>
                <li>
                  Lino Heurlin Vazquez (FRA, bronze)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Épée féminine individuelle junior (160 tireuses)<ol>
                <li>
                  Hadley Husisian (USA, or)</li>
                <li>
                  Nicole Feygin (ISR, argent)</li>
                <li>
                  Aleyna Erturk (TUR, bronze)</li>
                <li>
                  Ketki Ketkar (USA, bronze)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Épée masculine individuelle cadet (142 tireurs)<ol>
                <li>
                  Samuel Imrek (USA, or)</li>
                <li>
                  Alon Sarid (ISR, argent)</li>
                <li>
                  Fabio Mastromarino (ITA, bronze)</li>
                <li>
                  Maksym Perchuk (UKR, bronze)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Épée féminine individuelle cadet (109 tireuses)<ol>
                <li>
                  Aleyna Erturk (TUR, or)</li>
                <li>
                  Anna Maksymenko (UKR, argent)</li>
                <li>
                  Hailin Chen (HKG, bronze)</li>
                <li>
                  Mizuki Homma (JPN, bronze)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Épée masculine par équipes junior (42 équipes)<ol>
                <li>
                  Égypte (or)</li>
                <li>
                  États-Unis (argent)</li>
                <li>
                  France (bronze)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Épée féminine par équipes junior (33 équipes)<ol>
                <li>
                  Israël (or)</li>
                <li>
                  Pologne (argent)</li>
                <li>
                  États-Unis (bronze)</li>
              </ol>
            </li>
          </ul>
          <p>Tableau complet des médailles</p>
          <ol>
            <li>
              USA - 6 OR, 3 argent, 6 Bronze - 15 Total</li>
            <li>
              ITA - 2 OR, 2 argent, 4 Bronze - 8 Total</li>
            <li>
              GER - 1 OR, 2 argent, 1 Bronze - 4 Total</li>
            <li>
              ISR - 1 OR, 2 argent, 0 Bronze - 3 Total</li>
            <li>
              FRA - 1 OR, 1 argent, 4 Bronze - 6 Total</li>
            <li>
              JPN - 1 OR, 1 argent, 3 Bronze - 5 Total</li>
            <li>
              HUN - 1 OR, 1 argent, 2 Bronze - 4 Total</li>
            <li>
              EGY - 1 OR, 1 argent, 1 Bronze - 3 Total</li>
            <li>
              TUR - 1 OR, 0 argent, 1 Bronze - 2 Total</li>
            <li>
              HKG - 1 OR, 0 argent, 1 Bronze - 2 Total</li>
            <li>
              UZB - 1 OR, 0 argent, 1 Bronze - 2 Total</li>
            <li>
              CAN - 1 OR, 0 argent, 0 Bronze - 1 Total</li>
            <li>
              UKR - 0 OR, 1 argent, 2 Bronze - 3 Total</li>
            <li>
              GBR - 0 OR, 1 argent, 2 Bronze - 3 Total</li>
            <li>
              KOR - 0 OR, 1 argent, 2 Bronze - 3 Total</li>
            <li>
              POL - 0 OR, 1 argent, 0 Bronze - 1 Total</li>
            <li>
              ROU - 0 OR, 1 argent, 0 Bronze - 1 Total</li>
          </ol>
      `,
      "script": `
        function onPageEnter() {
          pg39Anim = new TimelineMax();
          pg39Anim
            .fromTo(cOf("39-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("39-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("39-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("39-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        
        function onPageLeave() {
          pg39Anim.stop();
          resetNumbers("39-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  LES CHAMPIONNATS DU MONDE D'ESCRIME JUNIORS ET CADETS 2022 AUSSI GRANDIOSES QUE RÉUSSIS À DUBAÏ DUBAÏ, ÉMIRATS ARABES UNIS 2 AU 10 AVRIL 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 39,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg40.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-red.png">
        </a>

        <img id="40-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg40Anim = new TimelineMax();
          pg40Anim
            .fromTo(idOf("40-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg40Anim.stop();
          resetNumbers("40-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "LES CHAMPIONNATS DU MONDE D'ESCRIME JUNIORS ET CADETS DUBAÏ, ÉMIRATS ARABES UNIS 2/5  Les Championnats du monde d'escrime juniors et cadets 2022 ont été qualifiés de « succès spectaculaire » par le président intérimaire de la FIE, Emmanuel Katsiadakis. La compétition, qui se déroulait sur neuf jours et comptait 18 épreuves individuelles et par équipes pour les tireurs et tireuses juniors et cadets, a enregistré le plus grand nombre de participants de son histoire, avec 1 357 escrimeurs en lice venus de 103 pays. Les championnats ont été organisés dans l'impressionnant Complexe sportif Hamdan de Dubaï, un complexe multisports de calibre mondial connu pour avoir accueilli un grand nombre de championnats et événements internationaux.  Le tableau suivant récapitule le nombre de pays ayant participé aux Championnats du monde d'escrime juniors et cadets, par régions continentales : Afrique			13 Amériques		 20 Asie/Océanie 32 Europe			38 Total			103 La cérémonie d'ouverture officielle des championnats s'était déroulée en présence de plusieurs dignitaires locaux : Son Excellence Dr. Ahmad bin Abdullah Humaid Belhoul Al Falasi, Ministre d'État en charge de l'Entreprenariat et des PME, et Président du Conseil d'administration de l'Autorité sportive générale ; Son Excellence Sheikh Salem bin Sultan Al Qasimi, membre du Comité exécutif de la FIE, président de la"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 40,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg41.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-red.png">
        </a>

        <img id="41-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg41Anim = new TimelineMax();
          pg41Anim
            .fromTo(idOf("41-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg41Anim.stop();
          resetNumbers("41-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "LES CHAMPIONNATS DU MONDE D'ESCRIME JUNIORS ET CADETS DUBAÏ, ÉMIRATS ARABES UNIS 3/5  Confédération asiatique d'escrime, président de la Fédération arabe d'escrime et président de la Fédération d'escrime des EAU ; Son Excellence Saeed Hareb, secrétaire général du Comité sportif de Dubaï ; et Son Excellence Nasser Al Rahma, vice-président du complexe sportif de Hamdan. Les championnats ont été déclarés officiellement ouverts par le Président intérimaire de la FIE, Emmanuel Katsiadakis. Trois jours de compétition consécutifs ont été consacrés à chaque arme (sabre, fleuret, épée). Chaque cycle de trois jours incluait les épreuves masculines et féminines individuelles juniors le premier jour, les épreuves individuelles cadets le deuxième jour et les épreuves par équipes juniors le dernier jour. Les protocoles COVID-19 ont été respectés pendant les Championnats afin de garantir la sécurité de tous les participants et des personnes présentes, avec notamment le port du masque, le respect des mesures de distanciation sociale et des tests réguliers. Les huit premiers au classement général des différentes épreuves sont les suivants :  SABRE • Sabre masculin individuel junior (152 tireurs) 1. Colin Heathcock (GER, or) 2. Pietro Torre (ITA, argent) 3. Antonio Heathcock (GER, bronze) 3. Heegeun Hwang (KOR, bronze) • Sabre féminin individuel junior (126 tireuses) 1. Magda Skarbonkiewicz (USA, or) 2. Honor Johnson (USA, argent) 3. Zaynab Dayibekova (UZB, bronze) 3. Sugar Katinka Battai (HUN, bronze)  • Sabre masculin individuel cadet (95 tireurs) 1. Zuhridden Kodirov (UZB, or) 2. Colin Heathcock (GER, argent) 3. Cody Ji (USA, bronze) 3. William Morrill (USA, bronze)"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 41,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg42.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-red.png">
        </a>

        <img id="42-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg42Anim = new TimelineMax();
          pg42Anim
            .fromTo(idOf("42-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg42Anim.stop();
          resetNumbers("42-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "LES CHAMPIONNATS DU MONDE D'ESCRIME JUNIORS ET CADETS DUBAÏ, ÉMIRATS ARABES UNIS 4/5  FLEURET •F  leuret masculin individuel junior (180 tireurs) 1. Kazuki Iimura (JPN, or) 2. Hyeonbhin An (KOR, argent) 3. Anas Anane (FRA, bronze) 3. Chase T. Emmer (USA, bronze)  • Sabre féminin individuel cadet (90 tireuses) 1. Magda Skarbonkiewicz (USA, or) 2. Siobhan Sullivan (USA, argent) 3. Alejandra Manga (FRA, bronze) 3. Eunyu Kim (KOR, bronze) •S  abre masculin par équipes junior (34 équipes) 1. Italie (or) 2. Roumanie (argent) 3. Égypte (bronze) • Sabre féminin par équipes junior (27 équipes) 1. France (or) 2. Hongrie (argent) 3. Italie (bronze)  • Fleuret féminin individuel junior (148 tireuses) 1. Lauren Scruggs (USA, or) 2. Yuzuha Takeyama (JPN, argent) 3. Carolina Stutchbury (GBR, bronze) 3. Kateryna Budenko (UKR, bronze) •F  leuret masculin individuel cadet (117 tireurs) 1. Tit Nam Cheng (HKG, or) 2. Ruben Lindner (GER, argent) 3. Matteo Iacomoni (ITA, bronze) 3. Andrew Chen (USA, bronze) • Fleuret féminin individuel cadet (104 tireuses) 1. Jessica Zi Jia Guo (CAN, or) 2. Carolina Stutchbury (GBR, argent) 3. Rino Nagase (JPN, bronze) 3. Matilde Molinari (ITA, bronze)"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 42,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg43.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-red.png">
        </a>
          
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:655px;left:45px" onclick="showOverlay('43-popups')"
          src="/120/fr/static/_content/trophy-red.png">
        
        <img id="43-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>

        <div id="43-popups" class="standardTransition contentOverlay hidden noclick">
          <img src="/120/fr/static/_content/39-popup-1.png" style="transform: scale(0.873); transform-origin: top left;">
          <div class="contentLink" style="top: 55px; left: 1015px; width: 35px; height: 35px;" onclick="hideOverlay('43-popups');"></div>
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg43Anim = new TimelineMax();
          pg43Anim
            .fromTo(idOf("43-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg43Anim.stop();
          resetNumbers("43-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "LES CHAMPIONNATS DU MONDE D'ESCRIME JUNIORS ET CADETS DUBAÏ, ÉMIRATS ARABES UNIS 5/5  • Fleuret masculin par équipes junior (37 équipes) 1. Italie (or) 2. France (argent) 3. Hongrie (bronze) • Fleuret féminin par équipes junior (32 équipes) 1. USA (or) 2. Italie (argent) 3. Japon (bronze) ÉPÉE •É  pée masculine individuelle junior (208 tireurs) 1. Zsombor Keszthelyi (HUN, or) 2. Mohamed Yasseen (EGY, argent) 3. James Jeal (GBR, bronze) 3. Lino Heurlin Vazquez (FRA, bronze)  Tableau complet des médailles  • Épée féminine individuelle junior (160 tireuses) 1. Hadley Husisian (USA, or) 2. Nicole Feygin (ISR, argent) 3. Aleyna Erturk (TUR, bronze) 3. Ketki Ketkar (USA, bronze)  •É  pée masculine individuelle cadet (142 tireurs) 1. Samuel Imrek (USA, or) 2. Alon Sarid (ISR, argent) 3. Fabio Mastromarino (ITA, bronze) 3. Maksym Perchuk (UKR, bronze) • Épée féminine individuelle cadet (109 tireuses) 1. Aleyna Erturk (TUR, or) 2. Anna Maksymenko (UKR, argent) 3. Hailin Chen (HKG, bronze) 3. Mizuki Homma (JPN, bronze) • Épée masculine par équipes junior (42 équipes) 1. Égypte (or) 2. États-Unis (argent) 3. France (bronze) • Épée féminine par équipes junior (33 équipes) 1. Israël (or) 2. Pologne (argent) 3. États-Unis (bronze) W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 43,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg44.jpg",
      "zoom": null,
      "content": `
        <a href="mailto:service@blue-gauntletservice.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 277px; right: 647px; width: 175px; height: 21px;"></div>
        </a>
        <!-- <a href="mailto:service@blue-gauntletservice.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 201px; right: 697px; width: 265px; height: 21px;"></div>
        </a> -->
        <a href="https://www.blue-gauntlet.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 255px; right: 685px; width: 135px; height: 21px;"></div>
        </a>
        <!-- <a href="https://www.blue-gauntlet.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 157px; right: 751px; width: 209px; height: 38px;"></div>
        </a> -->
      `,
      "mobileHtml": `
        <a href="https://www.blue-gauntlet.com" target="_blank">
          <img src="/120/fr/static/_content/44-mobile-1.jpg">
        </a>
      `,      
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 44,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg45.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 45-title" style="top:44px;left:61px;" src="/120/fr/static/_content/45-title-1.png">

        <img id="45-next" class="halfScale pointer" style="top:718px;right:-243px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-long-pink.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
        
        <div class="contentLink" onclick="showOverlay('45-popups')" style="    bottom: 413px; right: 161px; width: 40px; height: 33px;"></div>

        <div id="45-popups" class="standardTransition contentOverlay hidden noclick">
          <img id="45-pop-1" class="halfScale 45-popup" src="/120/fr/static/_content/45-popup-1.png" alt="">
          <img id="45-pop-2" class="halfScale 45-popup" src="/120/fr/static/_content/45-popup-2.png" style="opacity:0" alt="">
          <div class="contentLink" style="top:721px;left:600px;width:138px;height:48px;"
            onclick="togglePage45('45-pop-1', '45-popup');"></div>
          <div class="contentLink" style="top:721px;left:738px;width:138px;height:48px;"
            onclick="togglePage45('45-pop-2', '45-popup');"></div>
          <div class="contentLink" style="top: 40px; left: 1019px; width: 35px; height: 35px;"
            onclick="hideOverlay('45-popups');"></div>
        </div>
      `,
      "mobileHtml": `
        <h2
          id="bert-m-j-van-de-flier-ned-mh-given-royal-decoration-from-the-netherlands">
          Bert M.J. van de Flier (NED, MH) reçoit une décoration royale des Pays-Bas
        </h2>
        <img src="/120/fr/static/_content/45-mobile-1.jpg">
        <p><strong>Lausanne, Suisse<br>6 décembre 2021</strong></p>
        <p><strong>La FIE a eu le plaisir d'apprendre qu'un de ses Membres d'Honneur et Membres du Conseil du Fair Play de la FIE, Bert M. J. van der Flier (NED), a reçu une décoration royale, celle d'« Officier de l'ordre d'Orange-Nassau », de son Excellence Pieter de Gooijer, ambassadeur des Pays-Bas en France. La cérémonie s'est déroulée en présence de M. Dominique Breton, consul honoraire à Brest ; M. Guy Pennec, maire de Plourin-lès-Morlaix ; et Leon Pijnappel, président de la fédération royale néerlandaise d'escrime (KNAS). </strong></p>
        <p>Cette décoration, dont le grade est supérieur à celui de chevalier, est l'une des distinctions les plus importantes pouvant être décernées à un civil par les Pays-Bas, et lui a été remise en reconnaissance de ses nombreuses années de service et de dévouement à l'escrime néerlandaise, européenne et mondiale. Pendant de nombreuses années, M. van de Flier a en effet assumé différentes fonctions au sein de la famille de l’escrime, et obtenu des résultats qui ont motivé cette distinction.</p>
        <p>M. van de Flier a été nommé Membre d'honneur de la FIE par le Congrès 2013 à Paris, et intronisé au Hall of Fame de la FIE en 2014. Il a été membre de la Commission d'échelle des votes de la FIE, du Panel disciplinaire, et il a également présidé le Conseil du Fair Play de la FIE. Il a été président du DT lors des Championnats du monde, et a assumé à plusieurs reprises la fonction de superviseur officiel lors de compétitions de la Coupe du monde de la FIE.</p>
        <p>Depuis 2012, M. van de Flier travaille au Comité international du Fair Play (CIFP), dont il est le secrétaire-trésorier depuis 2015. Son travail a abouti en 2017 à la création du Conseil du Fair Play de la FIE.</p>
        <p>M. van de Flier est également Membre d'Honneur de la KNAS depuis 1995, et s'implique activement dans l'organisation depuis 1978. Il a présidé sa Commission technique avant de devenir son secrétaire général en 1981 et son président intérimaire en 1982. Il est ensuite devenu le plus jeune président de la KNAS, une fonction qu'il a assumée pendant 12 ans. Après avoir quitté le conseil d'administration en 1995, il est revenu au sein de la fédération en 2010 comme secrétaire général, un poste qu'il occupe encore aujourd'hui. </p>
        <p>Il a contribué à la création de la Confédération européenne d'escrime en 1991, et a siégé à son conseil d'administration pendant 17 ans, en tant que secrétaire général, premier vice-président, trésorier et président de la Commission SEMI. Plusieurs championnats du monde et d'Europe ont été organisés aux Pays-Bas entre 1985 et 1995 grâce aux efforts de M. van de Flier, qui a également joué un rôle fondamental pour que le « Airborne Trophy » et le « Zoetermeer Trophy » deviennent (auparavant) des compétitions de la Coupe du monde de la FIE aux Pays-Bas.</p>
      `,
      "script": `
        function onPageEnter() {
          pg45Anim = new TimelineMax();
          pg45Anim
            .fromTo(cOf("45-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(idOf("45-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        function togglePage45(show, hide) {
          var show = idOf(show)
          var hide = cOf(hide)
          TweenMax.to(hide, 0.01, {opacity: 0});
          TweenMax.to(show, 0.01, {opacity:1});
        }
        function onPageLeave() {
          pg45Anim.stop();
          resetNumbers("45-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "ACTUALITÉS DE L A FIE  ACTUALITÉS DE LA FIE Bert M.J. van de Flier (NED, MH) reçoit une décoration royale des Pays-Bas Voir plus ici.  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 45,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg46.jpg",
      "zoom": null,
      "content": `
      <a href="https://www.fencewithfun.com" target="_blank">
        <div class="contentLinkNone" style="bottom: 259px; right: 22px; width: 33px; height: 154px;"></div>
      </a>
      `,
      "mobileHtml": `
        <a href="https://www.fencewithfun.com" target="_blank">
          <img src="/120/fr/static/_content/46-mobile-1.jpg">
        </a>
      `,      
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 46,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg47.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 47-title" style="top:106px;left:65px;" src="/120/fr/static/_content/47-title-1.png">
        <img class="abs halfScale 47-sub" style="top:421px;left:92px;" src="/120/fr/static/_content/47-sub-1.png">
        <img class="abs halfScale 47-line" style="top:424px;left:64px;" src="/120/fr/static/_content/47-line-1.png">
        <img id="47-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-green.png">
      `,
      "mobileHtml": `
        <h2 id="togo-hosts-fencing-equipment-repair-course">Le Togo accueille une formation sur la réparation des équipements d'escrime </h2>
        <img src="/120/fr/static/_content/47-mobile-1.jpg">
        <p><strong>Lomé, Togo, <br>14 janvier 2022</strong></p>
        <p><strong>La Fédération togolaise d'escrime a accueilli une formation sur la réparation des équipements d'escrime du 14 au 18 décembre 2021.</strong></p>
        <p>Les participants, au nombre de 14, appartenaient aux quatre ligues d'escrime de la région. La formation, organisée à la demande du président de la fédération, Victor Laméga, a été financée par la FIE, qui a également dépêché un expert et fourni du matériel et des outils.  M. Gilles Martinage (FRA), qui a travaillé comme armurier officiel et administré le contrôle des armes lors de nombreuses compétitions aux quatre coins du monde, a dirigé la préparation et la formation. </p>
        <p>Les 14 participants, qui possédaient des niveaux d'expérience variés, étaient des athlètes, des entraîneurs, des maîtres d'armes formés à Dakar ou à Alger, ou encore des athlètes en formation pour devenir entraîneurs. M. Koffi Kassefon, arbitre international et directeur technique de la fédération togolaise, a également suivi le programme. </p>
        <p>Le contenu théorique et informatif de la formation portait sur les systèmes de notation électriques, les aspects techniques du fonctionnement des armes et le règlement du matériel en vigueur. Les thèmes abordés incluaient la détection des défaillances, la réparation et le montage complet des armes, la vérification de l'installation des pistes et le contrôle approprié de son équipement personnel (par ex. lames, fils de corps, masques, etc.). </p>
        <p>La formation, qui était interactive et comprenait des exercices pratiques, visait à perfectionner et à mettre en pratique les compétences techniques des participants. Son contenu journalier était adapté aux intérêts personnels et aux compétences et attentes des participants, afin que chacun puisse reproduire de manière systématique les techniques apprises. Des exercices pratiques ont été réalisés à l'aide du matériel fourni par la FIE : 12 kits de réparation de base, trois sacs d'armurier et un kit spécial de réparation d'enrouleurs de câble. L'objectif de ces exercices étaient de reconditionner efficacement les armes de compétition, normaliser les fils de corps, réparer les enrouleurs, gérer les câbles de piste et réparer/gérer l'appareil de notation et les télécommandes associées. Les participants ont appris à tester l'ensemble des équipements, à tester et à détecter les défaillances, et à identifier et réaliser les réparations correctes nécessaires, notamment souder, coller les fils aux lames et réfectionner les filets métalliques pour obtenir une bonne conductivité. </p>
        <p>À l'issue de la formation, les participants étaient notamment capables d'évaluer et de réparer efficacement presque toutes les armes de compétition de la FIE, de tester et de réparer les fils de corps et les enrouleurs de câble, et de réparer les télécommandes des systèmes de notation ainsi que les câbles conçus pour connecter les enrouleurs de câble aux armes. </p>
        <p>Les participants ont reçu des certificats de présence. M. Martinage a salué leur enthousiasme, leur remarquable travail et leur sérieux tout au long de la formation. Le président de la fédération togolaise, M. Laméga, s'est également félicité de « l'esprit de cohésion » qui régnait pendant le programme.</p>
      `,
      "script": `
        function onPageEnter() {
          pg47Anim = new TimelineMax();
          pg47Anim
            .fromTo(cOf("47-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("47-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("47-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("47-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        
        function onPageLeave() {
          pg47Anim.stop();
          resetNumbers("47-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "ACTUALITÉS DES C ONFÉDÉR ATIONS E T DES FÉDÉR ATIONS NATIONALES  LE TOGO ACCUEILLE UNE FORMATION SUR LA RÉPARATION DES ÉQUIPEMENTS D'ESCRIME LOMÉ, TOGO, 14 JANVIER 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 47,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg48.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-green.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-green.png">
        </a>

        <img id="48-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-edge-green.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg48Anim = new TimelineMax();
          pg48Anim
            .fromTo(idOf("48-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg48Anim.stop();
          resetNumbers("48-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "ACTUALITÉS DES CONFÉDÉRATIONS ET DES FÉDÉRATIONS NATIONALES 2/3  La Fédération togolaise d'escrime a accueilli une formation sur la réparation des équipements d'escrime du 14 au 18 décembre 2021. Les participants, au nombre de 14, appartenaient aux quatre ligues d'escrime de la région. La formation, organisée à la demande du président de la fédération, Victor Laméga, a été financée par la FIE, qui a également dépêché un expert et fourni du matériel et des outils. M. Gilles Martinage (FRA), qui a travaillé comme armurier officiel et administré le contrôle des armes lors de nombreuses compétitions aux quatre coins du monde, a dirigé la préparation et la formation.  Les 14 participants, qui possédaient des niveaux d'expérience variés, étaient des athlètes, des entraîneurs, des maîtres d'armes formés à Dakar ou à Alger, ou encore des athlètes en formation pour devenir entraîneurs. M. Koffi Kassefon, arbitre international et directeur technique de la fédération togolaise, a également suivi le programme. Le contenu théorique et informatif de la formation portait sur les systèmes de notation électriques, les aspects techniques du fonctionnement des armes et le règlement du matériel en vigueur. Les thèmes abordés incluaient la détection des défaillances, la réparation et le montage complet des armes, la vérification de l'installation des pistes et le contrôle approprié de son équipement personnel (par ex. lames, fils de corps, masques, etc.). La formation, qui était interactive et comprenait des exercices pratiques, visait à perfectionner et à mettre en pratique les compétences techniques des participants. Son contenu journalier était adapté aux intérêts personnels et aux compétences et attentes des participants,"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 48,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg49.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/fr/static/_content/tw-green.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/fr/static/_content/fb-green.png">
        </a>

        <img id="49-next" class="halfScale pointer" style="top:647px;right:-79px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-pad-green.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg49Anim = new TimelineMax();
          pg49Anim
            .fromTo(idOf("49-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg49Anim.stop();
          resetNumbers("49-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "l'ensemble des équipements, à tester et à détecter les défaillances, et à identifier et réaliser les réparations correctes nécessaires, notamment souder, coller les fils aux lames et réfectionner les filets métalliques pour obtenir une bonne conductivité.  ACTUALITÉS DES CONFÉDÉRATIONS ET DES FÉDÉRATIONS NATIONALES 3/3  afin que chacun puisse reproduire de manière systématique les techniques apprises. Des exercices pratiques ont été réalisés à l'aide du matériel fourni par la FIE : 12 kits de réparation de base, trois sacs d'armurier et un kit spécial de réparation d'enrouleurs de câble. L'objectif de ces exercices étaient de reconditionner efficacement les armes de compétition, normaliser les fils de corps, réparer les enrouleurs, gérer les câbles de piste et réparer/ gérer l'appareil de notation et les télécommandes associées. Les participants ont appris à tester  À l'issue de la formation, les participants étaient notamment capables d'évaluer et de réparer efficacement presque toutes les armes de compétition de la FIE, de tester et de réparer les fils de corps et les enrouleurs de câble, et de réparer les télécommandes des systèmes de notation ainsi que les câbles conçus pour connecter les enrouleurs de câble aux armes. Les participants ont reçu des certificats de présence. M. Martinage a salué leur enthousiasme, leur remarquable travail et leur sérieux tout au long de la formation. Le président de la fédération togolaise, M. Laméga, s'est également félicité de « l'esprit de cohésion » qui régnait pendant le programme. ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 49,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg50.jpg",
      "zoom": null,
      "content": ``,
      "mobileHtml": `
        <img src="/120/fr/static/_content/50-mobile-1.jpg">
      `,      
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 50,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg51.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 51-title" style="top:99px;left:66px;" src="/120/fr/static/_content/51-title-1.png">

        <img id="51-next" class="halfScale pointer" style="top:718px;right:-243px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-long-orange.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>

        <div class="contentLink" onclick="showOverlay('51-popups-1')" style="bottom: 242px; right: 878px; width: 42px; height: 27px;"></div>
        <div class="contentLink" onclick="showOverlay('51-popups-2')" style="bottom: 472px; right: 314px; width: 31px; height: 23px;"></div>

        <div id="51-popups-1" class="standardTransition contentOverlay hidden noclick">
          <img id="51-pop-2-1" class="halfScale 51-popup-2" src="/120/fr/static/_content/51-popup-1-1.png" alt="">
          <div class="contentLink" style="top: 41px; left: 1040px; width: 35px; height: 35px;"
            onclick="hideOverlay('51-popups-1');"></div>  
        </div>
        <div id="51-popups-2" class="standardTransition contentOverlay hidden noclick">
          <img id="51-pop-2-1" class="halfScale 51-popup-2A" src="/120/fr/static/_content/51-popup-2-1.png" alt="">
          <img id="51-pop-2-2" class="halfScale 51-popup-2" src="/120/fr/static/_content/51-popup-2-2.png" style="opacity:0" alt="">
          <div class="contentLink" style="top: 798px; left: 600px; width: 125px; height: 48px;"
            onclick="togglePage51('51-pop-2-1', '51-popup-2');"></div>
          <div class="contentLink" style="top: 798px; left: 755px; width: 125px; height: 48px;"
            onclick="togglePage51('51-pop-2-2', '51-popup-2');"></div>
          <div class="contentLink" style="top: 40px; left: 1040px; width: 35px; height: 35px;"
            onclick="hideOverlay('51-popups-2');"></div>
        </div>
      `,
      "mobileHtml": `
        <h2 id="fie-news">Actualités de la FIE</h2>
        <p><strong>1<br>Ateliers “Power-Up’’ du CIO Athlete365 Career+ </strong></p>
        <img src="/120/fr/static/_content/51-mobile-1.jpg">
        <p><strong>Des ateliers Athlete365 Career+ organisés dans le cadre des Championnats du monde d'escrime juniors et cadets 2022 à Dubaï.</strong></p>
        <p>Avant le début des Championnats du monde d'escrime juniors et cadets 2022 à Dubaï, Émirats Arabes Unis, un atelier « Power Up » a été organisé dans le cadre du programme Career+ Athlete 365 du CIO pour les tireurs participant au stage d'entraînement officiel de la FIE. L'atelier, animé par Maria Ntanou, triple olympienne et responsable de la communication numérique de la FIE, a été suivi par 16 tireurs de 16 pays distincts.</p>
        <p>Au cours de cet atelier d'une demi-journée, plusieurs thèmes ont été abordés, avec par exemple un module sur la manière d'identifier ses atouts et ses valeurs. </p>
        <p>L'atelier a permis d'expliquer que quel que soit le stade de sa carrière, il était important de prendre le temps de réfléchir et d'évaluer qui on était et ce que l'on souhaitait dans la vie. Il a également mis l'accent sur le fait qu'identifier ses « superpouvoirs », mais également ce qui nous motive et nous pousse vraiment, était utile dans tous les aspects de sa carrière et de sa vie.</p>
        <p>La première session était axée sur l'auto-réflexion et sur des activités menées par groupes d'athlètes pour répondre à des questions telles que : « Qu'est-ce qui est formidable chez moi ? », « En quoi pourrais-je être meilleur ? » et « Qu'est-ce qui est important pour moi ? » À la fin de la session, les tireurs étaient capables de citer trois de leurs principaux atouts et trois domaines dans lesquels ils pouvaient encore s'améliorer. </p>
        <p><strong>2<br>La FIE soutient la Journée internationale du sport au service du développement et de la paix le 6 avril dans le cadre des Championnats du monde d'escrime juniors et cadets à Dubaï</strong></p>
        <img src="/120/fr/static/_content/51-mobile-2.jpg">
        <p><strong>Dubaï, Émirats Arabes Unis, 6 avril 2022—C'est aujourd'hui la Journée internationale du sport au service du développement et de la paix (IDSDP), un mouvement créé par l'Assemblée générale des Nations Unies et soutenu par la FIE.</strong></p>
        <p>Chaque année, le 6 avril, le monde du sport met en avant le pouvoir unique du sport comme outil pour soutenir les personnes et les communautés afin de surmonter l'adversité et contribuer de manière significative au développement durable en étant un moteur essentiel. Il est reconnu que les activités sportives ont un impact positif sur la paix et l'harmonie dans la coexistence des communautés dans le monde.
        </p>
        <p>Lors des Championnats du monde d'escrime juniors et cadets, organisés du 2 au 10 avril à Dubaï, Émirats Arabes Unis, les athlètes ont reçu des informations sur l'IDSDP et ont été invités à tenir un carton blanc, le symbole emblématique de la Journée. En référence aux cartons jaune et rouge dans le monde du sport, le symbole #WhiteCard créé par l'organisation Peace and Sport représente depuis 2014 le pouvoir positif du sport en faveur de la paix et de l'inclusion sociale.</p>
        <p>De jeunes athlètes internationaux qui participaient aux Championnats du monde d'escrime juniors et cadets dans les différentes armes (épée, fleuret, sabre) et des deux genres ont fait part de leurs réflexions sur l'initiative du 6 avril :
        </p>
        <p>« Le sport est une manière de nous lier par quelque chose que nous avons tous en commun. Il y a des milliers de tireurs ici qui mettent de côté leurs différences pour participer à la compétition. Bien sûr, c'est impossible de faire cela sans paix. »</p>
        <p>Jakob Lars Kristmannson (ISL)</p>
        <p>« La paix et le sport unifient les gens, même s'ils sont en compétition. Il y a un haut niveau d'esprit sportif et de compréhension, c'est donc un super moyen pour réunir les gens. »</p>
        <p>Sanojah Gilkes (BAR)</p>
        <p>« Les sports comme l'escrime réunissent les gens ; ils se mesurent les uns aux autres mais sont également des camarades. En tant que sportif, même si vous combattez, vous voulez être sur d'être en paix lorsque vous n'êtes pas en compétition, pouvoir vous rapprocher des autres et échanger avec eux. »</p>
        <p>Daniella Weng Yan Tang (SGP)</p>
        <p>D'après l'organisation Peace and Sport : « Par le biais d'un #WhiteCard, nous pouvons tous sensibiliser sur le pouvoir unique du sport en faveur du développement social et de la paix, et partager une histoire sur la manière dont le sport nous a aidés à surmonter des difficultés. »</p>
      `,
      "script": `
        function onPageEnter() {
          pg51Anim = new TimelineMax();
          pg51Anim
            .fromTo(cOf("51-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(idOf("51-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        function togglePage51(show, hide) {
          var show = idOf(show)
          var hide = cOf(hide)
          TweenMax.to(hide, 0.01, {opacity: 0});
          TweenMax.to(show, 0.01, {opacity:1});
        }
        function onPageLeave() {
          pg51Anim.stop();
          resetNumbers("51-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "ACTUALITÉS  ACTUALITÉS DE LA FIE 2  WWW.FIE.ORG  La FIE soutient la Journée internationale du sport au service du développement et de la paix Voir plus ici.  1  Ateliers “Power-Up’’ du CIO Athlete365 Career+ Voir plus ici.  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 51,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg52.jpg",
      "zoom": null,
      "content": `
        <a href="mailto:jason@jiangfencing.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 76px; right: 352px; width: 235px; height: 19px;"></div>
        </a>
        <a href="http://www.jiangfencing.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 97px; right: 377px; width: 211px; height: 17px;"></div>
        </a>
      `,
      "mobileHtml": `
        <a href="http://www.jiangfencing.com" target="_blank">
          <img src="/120/fr/static/_content/52-mobile-1.jpg">
        </a>
      `,      
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 52,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg53.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 53-title" style="top:41px;left:61px;" src="/120/fr/static/_content/53-title-1.png">

        <img id="53-next" class="halfScale pointer" style="top:719px;right:-184px" onclick="Publish.goToNextPage()"
          src="/120/fr/static/_content/arrow-long-navy.png">
        
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>

        <div id="53-1" class="abs noOverflow 53-div" style="top:299px; left: 65px; height: 520px; width: 810px; display: block;">
          <img id="53-text-1a" class="halfScale 53-text-1" style="top:0px;left:0px;"
            src="/120/fr/static/_content/53-text-1-1.png">
          <img id="53-text-1b" class="halfScale 53-text-1" style="top:0px;left:0px; opacity:0;"
            src="/120/fr/static/_content/53-text-1-2.png">
          <div id="53-btn-1a" class="abs halfScale pointer 53-btn-1"
            style="top: 430px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('53-btn-1a', '53-btn-1', '53-text-1a', '53-text-1')"></div>
          <div id="53-btn-1b" class="abs halfScale pointer 53-btn-1"
            style="top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-1b', '53-btn-1', '53-text-1b', '53-text-1')"></div>
        </div>
        
        <div id="53-2" class="abs noOverflow 53-div" style="top:299px;left:65px;height:700px;width:880px;display:none">
          <img id="53-text-2a" class="halfScale 53-text-2" style="top:0px;left:0px;"
            src="/120/fr/static/_content/53-text-2-1.png">
          <img id="53-text-2b" class="halfScale 53-text-2" style="top:0px;left:0px; opacity:0;"
            src="/120/fr/static/_content/53-text-2-2.png">
          <div id="53-btn-2a" class="abs halfScale pointer 53-btn-2"
            style="top: 430px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('53-btn-2a', '53-btn-2', '53-text-2a', '53-text-2')"></div>
          <div id="53-btn-2b" class="abs halfScale pointer 53-btn-2"
            style="top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-2b', '53-btn-2', '53-text-2b', '53-text-2')"></div>
        </div>
        
        <div id="53-3" class="abs noOverflow 53-div" style="top:299px;left:65px;height:700px;width:880px;display:none">
          <img id="53-text-3a" class="halfScale 53-text-3" style="top:0px;left:0px;"
            src="/120/fr/static/_content/53-text-3-1.png">
          <img id="53-text-3b" class="halfScale 53-text-3" style="top:0px;left:0px; opacity:0;"
            src="/120/fr/static/_content/53-text-3-2.png">
          <div id="53-btn-3a" class="abs halfScale pointer 53-btn-3"
            style="top: 430px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('53-btn-3a', '53-btn-3', '53-text-3a', '53-text-3')"></div>
          <div id="53-btn-3b" class="abs halfScale pointer 53-btn-3"
            style="top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-3b', '53-btn-3', '53-text-3b', '53-text-3')"></div>
        </div>
        
        <div id="53-4" class="abs noOverflow 53-div" style="top:299px;left:65px;height:700px;width:880px;display:none">
          <img id="53-text-4a" class="halfScale 53-text-4" style="top:0px;left:0px;"
            src="/120/fr/static/_content/53-text-4-1.png">
          <img id="53-text-4b" class="halfScale 53-text-4" style="top:0px;left:0px; opacity:0;"
            src="/120/fr/static/_content/53-text-4-2.png">
          <img id="53-text-4c" class="halfScale 53-text-4" style="top:0px;left:0px; opacity:0;"
            src="/120/fr/static/_content/53-text-4-3.png">
          <div id="53-btn-4a" class="abs halfScale pointer 53-btn-4"
            style="top: 430px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('53-btn-4a', '53-btn-4', '53-text-4a', '53-text-4')"></div>
          <div id="53-btn-4b" class="abs halfScale pointer 53-btn-4"
            style="top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-4b', '53-btn-4', '53-text-4b', '53-text-4')"></div>
          <div id="53-btn-4c" class="abs halfScale pointer 53-btn-4"
            style="top: 430px; left: 705px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-4c', '53-btn-4', '53-text-4c', '53-text-4')"></div>
        </div>
        
        <div id="53-5" class="abs noOverflow 53-div" style="top:299px;left:65px;height:700px;width:880px;display:none">
          <img id="53-text-5a" class="halfScale 53-text-5" style="top:0px;left:0px;"
            src="/120/fr/static/_content/53-text-5-1.png">
          <img id="53-text-5b" class="halfScale 53-text-5" style="top:0px;left:0px; opacity:0;;"
            src="/120/fr/static/_content/53-text-5-2.png">
          <img id="53-text-5c" class="halfScale 53-text-5" style="top:0px;left:0px; opacity:0;;"
            src="/120/fr/static/_content/53-text-5-3.png">
          <div id="53-btn-5a" class="abs halfScale pointer 53-btn-5"
            style="top: 430px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('53-btn-5a', '53-btn-5', '53-text-5a', '53-text-5')"></div>
          <div id="53-btn-5b" class="abs halfScale pointer 53-btn-5"
            style="top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-5b', '53-btn-5', '53-text-5b', '53-text-5')"></div>
          <div id="53-btn-5c" class="abs halfScale pointer 53-btn-5"
            style="top: 430px; left: 705px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-5c', '53-btn-5', '53-text-5c', '53-text-5')"></div>
        </div>
        
        <div id="53-6" class="abs noOverflow 53-div" style="top:299px;left:65px;height:700px;width:880px;display:none">
          <img id="53-text-6a" class="halfScale 53-text-6" style="top:0px;left:0px;"
            src="/120/fr/static/_content/53-text-6-1.png">
          <img id="53-text-6b" class="halfScale 53-text-6" style="top:0px;left:0px; opacity:0;"
            src="/120/fr/static/_content/53-text-6-2.png">
          <img id="53-text-6c" class="halfScale 53-text-6" style="top:0px;left:0px; opacity:0;"
            src="/120/fr/static/_content/53-text-6-3.png">
          <div id="53-btn-6a" class="abs halfScale pointer 53-btn-6"
            style="top: 430px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('53-btn-6a', '53-btn-6', '53-text-6a', '53-text-6')"></div>
          <div id="53-btn-6b" class="abs halfScale pointer 53-btn-6"
            style="top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-6b', '53-btn-6', '53-text-6b', '53-text-6')"></div>
          <div id="53-btn-6c" class="abs halfScale pointer 53-btn-6"
            style="top: 430px; left: 705px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-6c', '53-btn-6', '53-text-6c', '53-text-6')"></div>
        </div>
        
        <img id="53-cta-1" class="halfScale pointer 53-btn" style="top:258px;left:869px;transform:scale(0.506,0.52);"
          onclick="pg53Toggle('53-1', '53-cta-1');" src="/120/fr/static/_content/53-name-1.png">
        <img id="53-cta-2" class="halfScale pointer 53-btn" style="top:325px;left:869px;transform:scale(0.506,0.52);opacity:0"
          onclick="pg53Toggle('53-2', '53-cta-2');" src="/120/fr/static/_content/53-name-2.png">
        <img id="53-cta-3" class="halfScale pointer 53-btn" style="top:393px;left:869px;transform:scale(0.506,0.52);opacity:0"
          onclick="pg53Toggle('53-3', '53-cta-3');" src="/120/fr/static/_content/53-name-3.png">
        <img id="53-cta-4" class="halfScale pointer 53-btn" style="top:461px;left:869px;transform:scale(0.506,0.52);opacity:0"
          onclick="pg53Toggle('53-4', '53-cta-4');" src="/120/fr/static/_content/53-name-4.png">
        <img id="53-cta-5" class="halfScale pointer 53-btn" style="top:528px;left:869px;transform:scale(0.506,0.52);opacity:0"
          onclick="pg53Toggle('53-5', '53-cta-5');" src="/120/fr/static/_content/53-name-5.png">
        <img id="53-cta-6" class="halfScale pointer 53-btn" style="top:595px;left:869px;transform:scale(0.506,0.52);opacity:0"
          onclick="pg53Toggle('53-6', '53-cta-6');" src="/120/fr/static/_content/53-name-6.png">
      `,
      "mobileHtml": `
        <h2 id="obituaries">NÉCROLOGIES</h2>
        <p><strong>1<br>Jahangir Safarov (AZE)</strong></p>
        <img src="/120/fr/static/_content/53-mobile-1.png">
        <p><strong>LAUSANNE, Suisse, 10 décembre 2021—C’est avec une grande tristesse que la FIE a appris le décès de Jahangir Safarov (AZE), le 12 novembre. Jahangir Safarov était entraîneur de l’équipe nationale d’escrime de l’Azerbaïdjan, ainsi qu’arbitre national.</strong></p>
        <p>Né le 9 mars 1968, c’est à l’âge de 10 ans qu’il commença l’escrime. Il fut médaillé à de nombreuses reprises dans des compétitions organisées en URSS, et participa à des Championnats du monde et d’Europe. Il fut nommé Maître émérite du sport de l’URSS en 1985. </p>
        <p>Il devint entraîneur de l’équipe nationale d’Azerbaïdjan en 2001, et forma plusieurs champions nationaux ainsi que des tireurs médaillés dans des compétitions internationales et régionales. Il fut également entraîneur en chef de l’équipe cadette de sabre féminin. L’une de ses élèves, Zarifa Huseynova, a décroché la médaille de bronze du sabre cadet en individuel lors des Championnats du monde d’escrime juniors et cadets 2021 au Caire. Son fils, Javanshir Safarov, qu’il entraîna également, fut médaillé d’argent au sabre lors de la Coupe du monde junior de Téhéran en décembre 2013. </p>
        <p>Au nom de la famille mondiale de l’escrime, la FIE présente ses sincères condoléances à la famille de M. Jahangir Safarov et à ses amis, à la Fédération azerbaïdjanaise d’escrime et à la Confédération européenne d’escrime, et tient à leur exprimer sa plus profonde sympathie en ces moments difficiles.</p>
        <p><strong>2<br>Alex Orban (USA) </strong></p>
        <img src="/120/fr/static/_content/53-mobile-2.png">
        <p><strong>LAUSANNE, Suisse, 9 décembre 2021—C’est avec tristesse que la FIE a appris le décès de M. Alex Orban (USA), Olympien à trois reprises au sabre, le 2 décembre à l’âge de 82 ans. </strong></p>
        <p>Né le 25 août 1939 à Budapest, Hongrie, Alex Orban a commencé l’escrime à l’âge de 14 ans. À 16 ans, il fut le plus jeune tireur de l’histoire à atteindre un haut de classement en Hongrie, ce qui lui valut le surnom d’« étoile montante des équipes Magyars ». </p>
        <p>M. Orban déménagea aux États-Unis et après trois années de service dans l’US Army, il s’entraîna et reprit les compétitions d’escrime. Il devint membre de l’équipe olympique américaine d’escrime et participa aux Jeux Olympiques de 1968 (Mexico), 1972 (Munich) et 1976 (Montréal). </p>
        <p>Il fut champion national des États-Unis au sabre en 1965, puis de 1969 à 1972, et médaillé d’or au sabre individuel aux Jeux panaméricains de 1971 à Cali, Colombie. M. Orban a également été médaillé d’argent au sabre par équipes aux Jeux panaméricains de 1971 et 1975 (Mexico). Il fut le premier sabreur américain à remporter une compétition internationale de classe A, en 1968 à Lodz, Pologne. M. Orban a été intronisé au Hall of Fame de l’escrime américaine en 1999.</p>
        <p>Au nom de la famille mondiale de l’escrime, la FIE présente ses sincères condoléances à la famille de M. Alex Orban et à ses amis, à la Fédération américaine d’escrime et à la Confédération panaméricaine d’escrime, et tient à leur exprimer sa plus profonde sympathie en ces moments difficiles.</p>
        <p><strong>3<br>Ali Youssef Hussain (KUW, MH)</strong></p>
        <img src="/120/fr/static/_content/53-mobile-3.png">
        <p><strong>LAUSANNE, Suisse, 30 décembre 2021—C’est avec une grande tristesse que la FIE a appris le décès d’Ali Youssef Hussain (KUW), Membre d’honneur et membre du Hall of Fame de la FIE, le 26 décembre dernier, à l’âge de 83 ans.</strong></p>
        <p>M. Hussain était un ancien membre du Comité exécutif de la FIE (2001-2008). Il fut nommé Membre d’honneur de la FIE par le Congrès en 2008. Il fut membre de la Commission Promotion de la FIE (nommée aujourd’hui Commission Promotion, Communication et Marketing) de 1985 à 2004.</p>
        <p>En 1977, il fut élu membre de la Kuwait Amateur Fencing Association, puis devint son président pendant huit années. Il fut également membre de son Conseil d’administration et de son Comité technique, ainsi que Responsable Produits de l’organisation. M. Hussain était membre du Conseil d’administration du Comité National Olympique du Koweït, et y a également assumé la fonction de secrétaire-trésorier de 1994 à 2014. </p>
        <p>Il a commencé à pratiquer plusieurs sports dès son plus jeune âge, et fut membre du Yarmouk Sports Club dès 1965, année de sa création. Il fut membre de son Conseil d’administration pendant 10 ans et y assuma les fonctions de secrétaire général et président.</p>
        <p>M. Hussain a suivi plusieurs cursus pédagogiques, notamment une formation olympique universitaire internationale en gestion du sport en 1987. Il a également étudié les Sciences du management et métiers du sport sous la supervision de la Fédération sportive arabe, ce qui lui a permis dès 1988 de poursuivre sa carrière dans l’administration sportive. </p>
        <p>La FIE présente ses sincères condoléances à la famille et aux amis d’Ali Youssef Hussain, à la Kuwait Fencing Amateur Association et à la Confédération asiatique d’escrime, et tient à leur exprimer sa plus profonde sympathie en ces moments difficiles.</p>
        <p></p>
        <p><strong>4<br>Olga Orban-Szabov (ROU)</strong></p>
        <img src="/120/fr/static/_content/53-mobile-4.png">
        <p><strong>LAUSANNE, Suisse, 17 janvier 2022—C’est avec une grande tristesse que la FIE a appris le décès d’Olga Orban-Szabo (ROM), multiple médaillée olympique et championne du monde, et membre du Hall of Fame de la FIE, le 5 janvier dernier. </strong></p>
        <p>Née le 9 octobre 1938 à Cluj, Mme Szabo fut la première médaillée olympique et championne du monde de la Roumanie. Elle participa à cinq Jeux Olympiques (Melbourne 1956, Rome 1960, Tokyo 1964, Mexico 1968 et Munich 1972). Elle remporta sa première médaille olympique, une médaille d’argent au fleuret individuel, à Melbourne, puis une médaille de bronze au fleuret par équipes aux Jeux de Mexico et de Munich. 
        </p>
        <p>Elle fut sacrée championne du monde de fleuret individuel aux Championnats du monde de Buenos Aires en 1962. Avec l’équipe roumaine de fleuret féminin, aux côtés de Maria Vicol, Ileana Gyulai, Ecaterina Stahl et Ana Pascu, elle remporta une médaille d’or aux Championnats du monde de La Havane 1969, une autre première dans l’histoire de son pays. 
        </p>
        <p>Entre 1961 et 1970, Mme Orban-Szabo remporta au total 11 médailles au fleuret aux Jeux Olympiques et aux Championnats du monde (trois aux J.O. et huit aux Championnats du monde). Avant cela, elle fut vice-championne du monde junior en 1959. Elle remporta également trois médailles aux Universiades : une médaille d’argent en individuel et une médaille d’or par équipes en 1961, et une médaille d’argent par équipes en 1965.
        </p>
        <p>En tant que membre du club de l’armée « Steaua Bucarest », elle remporta sept fois le championnat national roumain, et reçut le titre national de « Maître émérite du sport » ainsi que de nombreux ordres et titres roumains. Elle était diplômée de l’Université Babes-Bolyai à Cluj-Napoca, et également Maître d’armes. Suite à sa retraite sportive en 1972, elle travailla comme entraîneur d’escrime pour les jeunes dans son club à Bucarest.</p>
        <p>« C’était une Lady prestigieuse de l’équipe d’escrime roumaine, » a déclaré Marius Florea, président de la fédération roumaine. « La Fédération roumaine d’escrime aimerait exprimer sa profonde reconnaissance et sa gratitude à Mme Olga Orban-Szabo pour sa contribution à la création de la famille roumaine de l’escrime. » </p>
        <p>La FIE présente ses sincères condoléances à la famille et aux amis d’Olga Orban-Szabo, à la Fédération roumaine d’escrime et à la Confédération européenne d’escrime, et tient à leur exprimer sa plus profonde sympathie en ces moments difficiles.</p>
        <p><strong>5<br>Jose Valarinho (POR)</strong></p>
        <img src="/120/fr/static/_content/53-mobile-5.png">
        <p><strong>LAUSANNE, Suisse, 4 avril 2022—C’est avec une grande tristesse que la FIE a appris le décès de M. José Valarinho (POR), Membre du Hall of Fame de la FIE, le 30 mars 2022 à l’âge de 87 ans. Il fut membre du Comité disciplinaire de la FIE de 1996 à 2004. </strong></p>
        <p>Il fut trois fois récompensé d’une médaille d’or spéciale de la FIE pour ses travaux universitaires sur l’escrime et pour l’organisation du Congrès de la FIE 1988 à Madère et des Championnats du monde 2002 à Lisbonne. Il reçut également l’Ordre Olympique du Comité olympique portugais, ainsi que la Médaille du mérite sportif, décerné par le gouvernement portugais. </p>
        <p>M. Valarinho fut président de la Fédération portugaise d’escrime pendant deux mandats à partir de 1992. Il rejoignit l’organisation en 1969 en tant que président de la Commission technique, et il eut pendant plusieurs décennies un impact considérable sur la croissance et le développement de l’escrime au Portugal. Il participa au « Plan pour le développement du sport » avec un programme spécial intitulé « 500 Foils » (500 fleurets), et œuvra pour que le Portugal devienne plus actif sur la scène de l’escrime internationale. </p>
        <p>M. Valarinho participa à l’organisation des premiers Championnats d’Europe à Lisbonne en 1983, et à celle de plusieurs autres compétitions continentales et internationales accueillies au Portugal au cours des années 80 et 90. Son souhait de voir le Portugal jouer un rôle actif sur la scène de l’escrime mondiale fut pleinement réalisé lorsque l’équipe de fleuret masculin de son pays remporta la médaille d’or des Championnats d’Europe 2000 à  Madère. Après son départ de la présidence, il organisa avec succès les Championnats du monde d’escrime 2002 à Lisbonne. </p>
        <p>Après avoir suivi un enseignement militaire portugais traditionnel, M. Valarinho devint Officier de l’armée. C’est pendant sa scolarité qu’il s’essaya à l’escrime pour la première fois, et devint également un cavalier talentueux. Il fut diplômé avec mention en tant que « maître » au Centre sportif militaire de Mafra, où il tirait en compétition, et participa aux Universiades de 1959 en tant que membre de l’équipe de sabre masculin. Après sa scolarité, il devint Maître d’armes et se spécialisa dans le recrutement et le développement de jeunes tireurs. </p>
        <p>Il écrivit deux livres sur l’histoire de l’escrime portugaise, et était en train de rédiger une troisième édition. </p>
        <p>« Ce fut un tireur jusqu’à son dernier souffle », a déclaré son fils, Frederico Valarinho, membre de la Fédération portugaise d’escrime depuis 2006. </p>
        <p>La FIE présente ses sincères condoléances à la famille et aux amis de José Valarinho, à la Fédération portugaise d’escrime et à la Confédération européenne d’escrime, et tient à leur exprimer sa plus profonde sympathie en ces moments difficiles.</p>
        <p> <strong>6<br>Ana Pascu (ROU, MH)</strong></p>
        <img src="/120/fr/static/_content/53-mobile-6.png">
        <p><strong>LAUSANNE, Suisse, 9 avril 2022—C’est avec une immense tristesse que la FIE a appris le décès à Bucarest, le 06 avril 2022, de Mme Ana Pascu (ROU), Membre d’honneur et membre du Hall of Fame de la FIE. Elle était née le 22 septembre 1944. </strong> </p>
        <p>Élue en 2000, Mme Pascu était membre du Comité exécutif de la FIE, et fut vice-présidente de 2004 à 2021. Avant cela, elle fut membre de la Commission des Règlements de la FIE de 1984 à 1988, et membre de la Commission de l’arbitrage de la FIE de 1988 à 1996. Elle fut également arbitre internationale de la FIE au fleuret et à l’épée. </p>
        <p>Elle détient le record du nombre de mandats effectués par un président de la Fédération roumaine d’escrime. De 1982 à 2013, Mme Pascu a dirigé la Fédération, contribuant au succès sportif des tireurs roumains qui ont remporté 134 médailles sous sa présidence : neuf aux Jeux olympiques, 57 aux Championnats du monde et 68 aux Championnats d’Europe. Suite à se retraite en tant que présidente, elle a été nommée présidente d’honneur de la Fédération roumaine d’escrime. Elle fut également vice-présidente du Comité olympique et sportif roumain. </p>
        <p>En tant qu’athlète, Mme Pascu participa cinq fois aux Jeux Olympiques au fleuret. Au fleuret par équipes, elle remporta une médaille de bronze aux Jeux Olympiques de 1968 et 1972, et une médaille d’or aux Championnats du monde de La Havane 1969. Au fleuret individuel, elle fut sacrée championne du monde junior en 1963 et décrocha également la médaille de bronze aux Championnats du monde 1971. En tant que membre de l’équipe roumaine de fleuret féminin, elle remporta la médaille d’argent de fleuret par équipes aux Championnats du monde 1970, et la médaille de bronze aux Championnats du monde 1961, 1967, 1971, 1973, 1974 et 1975. En 1961 et 1965, son équipe remporta l’or et l’argent, respectivement, des Jeux mondiaux universitaires (« Universiade »). </p>
        <p>Mme Pascu fut également entraîneur d’escrime et professeur d’éducation physique jusqu’en 1982, après avoir obtenu son doctorat en éducation physique et sportive. La thèse de son doctorat était intitulée « The Strategy for Enhancing Sports Preparation in Competitions » (Stratégie pour améliorer la préparation sportive en compétition). Elle reçut également un « Doctor Honoris Causa » de l’Université Vasile Goldis en Roumanie. Elle est l’auteur de nombreuses publications scientifiques et sportives, et a reçu de nombreux titres et décorations, notamment l’Ordre national du mérite au rang d’Officier et Chevalier. Mme Pascu a consacré sa vie entière à l’escrime, aux tireurs, à l’escrime roumaine et à la FIE, et les nombreuses succès qui en ont découlé témoignent de son incroyable talent et de sa passion pour notre sport. Emmanuel Katsiadakis, président intérimaire de la FIE, a dit d’elle : « Elle aidait, soutenait et motivait sans relâche, avec générosité et avec une gentillesse infinie, tout ceux qui demandaient son aide et des conseils. C’était une mentor extraordinaire et un modèle pour les athlètes, les officiels et les dirigeants de l’escrime, ainsi que pour les filles et les femmes dans le sport. » La FIE présente ses sincères condoléances à la famille de Mme Pascu et à ses amis, à la Fédération roumaine d’escrime et à la Confédération européenne d’escrime, et tient à leur exprimer sa plus profonde sympathie en ces moments difficiles.</p>
      `,
      "script": `
        function onPageEnter() {
          pg53Anim = new TimelineMax();
          pg53Anim
            .to(idOf("53-1"), 0.3,{display: 'block'}, 0)
            .fromTo(cOf("53-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(idOf("53-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function pg53Toggle(id, btn) {
          var ele = idOf(id)
          var but = idOf(btn)
          TweenMax.to(cOf("53-div"), 0.01, {display: 'none'});
          TweenMax.to(cOf("53-btn"), 0.01, {opacity: 0});
          TweenMax.to(ele, 0.1, {display: 'block'});
          TweenMax.to(but, 0.1, {opacity: 1});
        }
        
        function togglePage(id, klass, text, texttwo) {
          var ele = idOf(id)
          var but = cOf(klass)
          var txt = idOf(text)
          var txt2 = cOf(texttwo)
          TweenMax.to(but, 0.01, {opacity: 0});
          TweenMax.to(txt2, 0.01, {opacity: 0});
          TweenMax.to(ele, 0.01, {opacity:1});
          TweenMax.to(txt, 0.01, {opacity:1});
        }
        
        function onPageLeave(){
          pg53Toggle('53-text-1', '53-cta-1');
          togglePage('53-btn-1', '53-btn-2', '53-text-1', '53-text-1');
          pg53Anim.stop();
          resetNumbers("53-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "NÉCROLO GIE  NÉCROLOGIES JAHANGIR SAFAROV  JAHANGIR SAFAROV (AZE) des compétitions organisées en URSS, et participa à des Championnats du monde et d’Europe. Il fut nommé Maître émérite du sport de l’URSS en 1985.  LAUSANNE, Suisse, 10 décembre 2021—C’est avec une grande tristesse que la FIE a appris le décès de Jahangir Safarov (AZE), le 12 novembre. Jahangir Safarov était entraîneur de l’équipe nationale d’escrime de l’Azerbaïdjan, ainsi qu’arbitre national. Né le 9 mars 1968, c’est à l’âge de 10 ans qu’il commença l’escrime. Il fut médaillé à de nombreuses reprises dans  Il devint entraîneur de l’équipe nationale d’Azerbaïdjan en 2001, et forma plusieurs champions nationaux ainsi que des tireurs médaillés dans des compétitions internationales et régionales. Il fut également entraîneur en chef de l’équipe cadette de sabre féminin. L’une de ses élèves, Zarifa Huseynova, a décroché la médaille de  ALEX ORBAN  ALI YOUSSEF HUSSAIN  OLGA ORBAN-SZABO  JOSE VALARINHO  ANA PASCU  s Cliquez ici  1  2  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 53,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg54.jpg",
      "zoom": null,
      "content": `
        <a href="http://www.gfencing.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 186px; right: 599px; width: 228px; height: 38px;"></div>
        </a>
        <a href="mailto:sales@gfencing.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 186px; right: 340px; width: 236px; height: 38px;"></div>
        </a>
      `,
      "mobileHtml": `
        <a href="http://www.gfencing.com" target="_blank">
          <img src="/120/fr/static/_content/54-mobile-1.jpg">
        </a>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }
  
      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }
      
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
      }
  
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))
        
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
        contentLinksThree.map(function callback(e) { 
          return e.className = 'addContentLinkThree'
        })
      }
  
      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))

        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
        contentLinksThree.map(function callback(e) {
          return e.className = 'contentLinkThree addContentLinkThree'
        })
      }
  
      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }
  
      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = ",";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              console.log(obj.number)
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^\d*/)[0];
              console.log("PREDEC", predec, typeof(predec));
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              console.log("NEWSTR", newstr, typeof(newstr));
              // console.log({newstr})
              // var dp = str.split(/\.\d+/) ? str.split(/\.\d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }

      function individualGallery(index) {
        Publish.openGalleryTwo([['8-gal-1.jpg', '8-gal-2.jpg'], index])
      }
    `,
    "mobilePages": [
      {
        title: "Escrime XXI N⁰. 120",
        link: "Escrime XXI N⁰. 120",
        cssClass: "cover mobile-p1",
        hideInMenu: false,
        pageLinks: [
          {
            index: 0,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 2,
            subIndex: 0
          }
        ]
      },
      {
        title: "COMITÉ EXÉCUTIF DE LA FIE",
        link: "COMITÉ EXÉCUTIF DE LA FIE",
        cssClass: "blue",
        hideInMenu: false,
        pageLinks: [
          {
            index: 4,
            subIndex: 0
          }
        ]
      },
      {
        title: "ÉDITORIAL",
        link: "ÉDITORIAL",
        cssClass: "darkblue",
        hideInMenu: false,
        pageLinks: [
          {
            index: 5,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 6,
            subIndex: 0
          }
        ]
      },
      {
        title: "SPORT",
        link: "SPORT | Tashkent",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 7,
            subIndex: 0
          }
        ]
      },
      {
        title: "SPORT",
        link: "SPORT | Orleans",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 9,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 12,
            subIndex: 0
          }
        ]
      },
      {
        title: "SPORT",
        link: "SPORT | Tallinn",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 13,
            subIndex: 0
          }
        ]
      },
      {
        title: "SPORT",
        link: "SPORT | Bern",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 16,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 18,
            subIndex: 0
          }
        ]
      },
      {
        title: "SPORT",
        link: "SPORT | St Maur",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 19,
            subIndex: 0
          }
        ]
      },
      {
        title: "SPORT",
        link: "SPORT | Paris",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 21,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 23,
            subIndex: 0
          }
        ]
      },
      {
        title: "SPORT",
        link: "SPORT | Poznan",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 24,
            subIndex: 0
          }
        ]
      },
      {
        title: "SPORT",
        link: "SPORT | Tbilisi",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 26,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 29,
            subIndex: 0
          }
        ]
      },
      {
        title: "SPORT",
        link: "SPORT | Plovdiv",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 30,
            subIndex: 0
          }
        ]
      },
      {
        title: "SPORT",
        link: "SPORT | Doha",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 32,
            subIndex: 0
          }
        ]
      },
      {
        title: "SPORT",
        link: "SPORT | Budapest",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 34,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 37,
            subIndex: 0
          }
        ]
      },
      {
        title: "SPORT",
        link: "SPORT | Dubai",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 38,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 43,
            subIndex: 0
          }
        ]
      },
      {
        title: "FIE",
        link: "ACTUALITÉS DE LA FIE",
        cssClass: "pink",
        hideInMenu: false,
        pageLinks: [
          {
            index: 44,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 45,
            subIndex: 0
          }
        ]
      },
      {
        title: "ACTUALITÉS DES CONFÉDÉRATIONS ET DES FÉDÉRATIONS NATIONALES",
        link: "ACTUALITÉS DES CONFÉDÉRATIONS ET DES FÉDÉRATIONS NATIONALES | Togo",
        cssClass: "green",
        hideInMenu: false,
        pageLinks: [
          {
            index: 46,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 49,
            subIndex: 0
          }
        ]
      },
      {
        title: "ACTUALITÉS",
        link: "ACTUALITÉS",
        cssClass: "orange",
        hideInMenu: false,
        pageLinks: [
          {
            index: 50,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 51,
            subIndex: 0
          }
        ]
      },
      {
        title: "NÉCROLOGIES",
        link: "NÉCROLOGIES",
        cssClass: "grey",
        hideInMenu: false,
        pageLinks: [
          {
            index: 52,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 53,
            subIndex: 0
          }
        ]
      },
    ],
    "mobileTemplate": null,
  }


// WEBPACK FOOTER //
// ./src/document.js